/* ==========================================================================
   WISE BOUTIQUE — JavaScript du thème
   Panier Ajax + tiroir, variantes, offres par quantité, compte à rebours,
   guide des tailles, FAQ, suivi colis, roue, popup, chat, preuve sociale.
   ========================================================================== */
(function () {
  'use strict';

  var routes = window.WiseRoutes || {};
  var cfg = window.WiseSettings || {};

  /* ---------- Utilitaires ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    var fmt = cfg.moneyFormat || '{{amount_with_comma_separator}} €';
    var amount;
    if (fmt.indexOf('amount_no_decimals') !== -1) {
      amount = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    } else if (fmt.indexOf('amount_with_comma_separator') !== -1) {
      amount = whole + ',' + parts[1];
    } else {
      amount = whole + '.' + parts[1];
    }
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/g, amount).replace(/<[^>]+>/g, '');
  }

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function storageGet(key) { try { return window.localStorage.getItem(key); } catch (e) { return null; } }
  function storageSet(key, value) { try { window.localStorage.setItem(key, value); } catch (e) {} }

  /* Annonce pour lecteurs d'écran (région aria-live du layout) */
  function announce(message) {
    var region = $('#live-region');
    if (!region) return;
    region.textContent = '';
    setTimeout(function () { region.textContent = message; }, 60);
  }

  /* Verrouillage du défilement quand un panneau ou une modale est ouvert */
  var scrollLocks = 0;
  function lockScroll() {
    scrollLocks++;
    document.documentElement.classList.add('no-scroll');
  }
  function unlockScroll() {
    scrollLocks = Math.max(0, scrollLocks - 1);
    if (!scrollLocks) document.documentElement.classList.remove('no-scroll');
  }

  /* ---------- Barre latérale mobile ---------- */
  var side = $('#side');
  var backdrop = $('#side-backdrop');
  var burger = $('#burger');
  function openSide() {
    if (!side || side.classList.contains('is-open')) return;
    side.classList.add('is-open');
    if (backdrop) { backdrop.hidden = false; backdrop.classList.add('is-on'); }
    if (burger) burger.setAttribute('aria-expanded', 'true');
    lockScroll();
  }
  function closeSide() {
    if (!side || !side.classList.contains('is-open')) return;
    side.classList.remove('is-open');
    if (backdrop) { backdrop.classList.remove('is-on'); backdrop.hidden = true; }
    if (burger) burger.setAttribute('aria-expanded', 'false');
    unlockScroll();
  }
  if (burger) burger.addEventListener('click', openSide);
  if (backdrop) backdrop.addEventListener('click', closeSide);
  var sideClose = $('#side-close');
  if (sideClose) sideClose.addEventListener('click', closeSide);

  /* ---------- Panier : tiroir + Ajax ---------- */
  var drawer = $('#cart-drawer');
  var drawerBackdrop = $('#drawer-backdrop');

  var drawerReturnFocus = null;
  function openDrawer() {
    if (!drawer || drawer.classList.contains('is-on')) return;
    drawer.classList.add('is-on');
    drawer.setAttribute('aria-hidden', 'false');
    if (drawerBackdrop) drawerBackdrop.classList.add('is-on');
    lockScroll();
    drawerReturnFocus = document.activeElement;
    var closeBtn = drawer.querySelector('[data-drawer-close]');
    if (closeBtn) closeBtn.focus();
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-on')) return;
    drawer.classList.remove('is-on');
    drawer.setAttribute('aria-hidden', 'true');
    if (drawerBackdrop) drawerBackdrop.classList.remove('is-on');
    unlockScroll();
    if (drawerReturnFocus && drawerReturnFocus.focus) drawerReturnFocus.focus();
    drawerReturnFocus = null;
  }
  $all('[data-drawer-open]').forEach(function (btn) { btn.addEventListener('click', openDrawer); });
  $all('[data-drawer-close]').forEach(function (btn) { btn.addEventListener('click', closeDrawer); });
  if (drawerBackdrop) drawerBackdrop.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer();
      closeSide();
      closeGuide();
      closePopup();
    }
  });

  function renderDrawer(cart) {
    var body = $('#drawer-body');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="drawer__empty">Votre panier est vide' +
        '<a class="btn btn--dark btn--sm drawer__empty-cta" href="' + (cfg.shopUrl || '/collections/all') + '">Découvrir la boutique</a></div>';
    } else {
      body.innerHTML = cart.items.map(function (item, i) {
        var variant = item.variant_title && item.variant_title !== 'Default Title' ? esc(item.variant_title) : '';
        var img = item.image ? '<img src="' + esc(item.image) + (item.image.indexOf('?') === -1 ? '?width=140' : '&width=140') + '" alt="" width="60" height="70" loading="lazy">' : '';
        return '<div class="drawer__line">' + img +
          '<div class="drawer__line-i">' +
          '<div class="drawer__line-n"><a href="' + esc(item.url) + '">' + esc(item.product_title) + '</a></div>' +
          (variant ? '<div class="drawer__line-v">' + variant + '</div>' : '') +
          '<div class="drawer__line-b">' +
          '<span class="drawer__qty">' +
          '<button type="button" data-drawer-qty="-1" data-line="' + (i + 1) + '" data-qty="' + item.quantity + '" aria-label="Réduire la quantité">&minus;</button>' +
          '<b>' + item.quantity + '</b>' +
          '<button type="button" data-drawer-qty="1" data-line="' + (i + 1) + '" data-qty="' + item.quantity + '" aria-label="Augmenter la quantité">+</button>' +
          '</span>' +
          '<span class="drawer__line-p">' + formatMoney(item.final_line_price) + '</span>' +
          '</div></div>' +
          '<button class="drawer__line-x" data-drawer-remove data-line="' + (i + 1) + '" aria-label="Retirer ' + esc(item.product_title) + '">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
          '</button></div>';
      }).join('');
    }
    $all('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    $all('[data-cart-badge]').forEach(function (el) {
      el.hidden = cart.item_count === 0;
      el.classList.remove('is-bump');
      void el.offsetWidth;
      el.classList.add('is-bump');
    });
    var subtotal = $('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    updateShipProgress(cart.total_price);
    bindDrawerRemove();
    bindDrawerQty();
  }

  function updateShipProgress(totalCents) {
    var msg = $('[data-ship-msg]');
    var bar = $('[data-ship-bar]');
    var threshold = cfg.freeShipping || 0;
    if (!msg || !bar || !threshold) return;
    var wrap = bar.closest('[data-ship-wrap]');
    if (totalCents >= threshold) {
      msg.textContent = 'Livraison offerte débloquée !';
      bar.style.width = '100%';
      if (wrap) wrap.classList.add('is-free');
    } else {
      msg.textContent = 'Plus que ' + formatMoney(threshold - totalCents) + ' pour la livraison offerte';
      bar.style.width = Math.round(totalCents * 100 / threshold) + '%';
      if (wrap) wrap.classList.remove('is-free');
    }
  }

  function refreshCart() {
    return fetch(routes.cart + '.js')
      .then(function (r) { return r.json(); })
      .then(renderDrawer);
  }

  function changeLine(line, quantity) {
    return fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function () { return refreshCart(); });
  }

  function bindDrawerRemove() {
    $all('[data-drawer-remove]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        changeLine(parseInt(btn.getAttribute('data-line'), 10), 0)
          .then(function () { announce('Article retiré du panier'); });
      });
    });
  }
  bindDrawerRemove();

  function bindDrawerQty() {
    $all('[data-drawer-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.getAttribute('data-drawer-qty'), 10);
        var current = parseInt(btn.getAttribute('data-qty'), 10) || 1;
        var next = Math.max(0, current + delta);
        btn.disabled = true;
        changeLine(parseInt(btn.getAttribute('data-line'), 10), next);
      });
    });
  }
  bindDrawerQty();

  function addToCart(payload) {
    return fetch(routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return refreshCart();
    }).then(function () {
      announce('Produit ajouté au panier');
      openDrawer();
      attachRefAttribute();
    });
  }

  /* Parrainage automatique : le code enregistré par le filleul voyage en
     attribut de panier (la routine quotidienne le lit sur la commande), et
     sa remise de bienvenue est posée en cookie de paiement. */
  var REF_CODE_KEY = 'wise_ref_code';
  function attachRefAttribute() {
    var code = storageGet(REF_CODE_KEY);
    if (!code) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Code parrain': code } })
    }).catch(function () {});
  }
  attachRefAttribute();

  // Formulaires « ajouter au panier » (cartes produit + fiche produit)
  $all('product-form form, form[data-ajax-cart]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var checkoutClicked = e.submitter && e.submitter.name === 'checkout';
      if (checkoutClicked) return;
      e.preventDefault();
      var id = form.querySelector('[name="id"]');
      var qty = form.querySelector('[name="quantity"]');
      if (!id) return;
      var btn = form.querySelector('[type="submit"]');
      var prevHtml = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; }
      var flySource = form.closest('.card') || form.closest('.pdp');
      addToCart({ id: parseInt(id.value, 10), quantity: qty ? parseInt(qty.value, 10) || 1 : 1 })
        .then(function () {
          if (window.wiseFlyToCart && flySource) window.wiseFlyToCart(flySource.querySelector('img'));
          if (!btn) return;
          btn.classList.add('is-added');
          btn.innerHTML = 'Ajouté au panier';
          setTimeout(function () {
            btn.classList.remove('is-added');
            btn.innerHTML = prevHtml;
          }, 1600);
        })
        .catch(function () { window.location.href = routes.cart; })
        .then(function () { if (btn) btn.disabled = false; });
    });
  });

  // Ajout rapide (cross-sell panier)
  $all('[data-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.disabled = true;
      var mini = btn.closest('.mini-card');
      addToCart({ id: parseInt(btn.getAttribute('data-variant'), 10), quantity: 1 })
        .then(function () {
          if (window.wiseFlyToCart && mini) window.wiseFlyToCart(mini.querySelector('img')); if (document.body.classList.contains('template-cart')) window.location.reload(); })
        .catch(function () {})
        .then(function () { btn.disabled = false; });
    });
  });

  // Page panier : la saisie directe d'une quantité met à jour le panier
  $all('.cart-page .qty input').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });

  // Code promo — enregistré via l'URL de réduction Shopify
  var promoApply = $('[data-promo-apply]');
  if (promoApply) {
    promoApply.addEventListener('click', function () {
      var input = $('#promo-code');
      var code = input && input.value.trim();
      if (!code) return;
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(routes.cart || '/cart');
    });
  }

  /* ---------- Accordéons (fiche produit, page Box Mystère, etc.) ---------- */
  $all('.acc__q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.parentElement;
      var open = item.classList.toggle('is-open');
      q.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- Fiche produit ---------- */
  var pdp = $('[data-product]');
  if (pdp) {
    // Vignettes
    var mainImg = $('#pdp-main-img');
    $all('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        $all('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (mainImg) {
          var nextSrc = thumb.getAttribute('data-src');
          if (mainImg.src === nextSrc) return;
          mainImg.style.opacity = '0';
          setTimeout(function () {
            mainImg.onload = function () { mainImg.style.opacity = '1'; mainImg.onload = null; };
            mainImg.src = nextSrc;
            if (mainImg.complete) { mainImg.style.opacity = '1'; mainImg.onload = null; }
          }, 150);
        }
      });
    });

    // Variantes
    var variantsScript = $('[data-variants-json]');
    var variants = variantsScript ? JSON.parse(variantsScript.textContent) : null;
    var variantInput = $('[data-variant-id]');
    var currentPrice = parseInt(($('[data-price]') || {}).getAttribute ? $('[data-price]').getAttribute('data-unit') : 0, 10) || 0;
    var bundleState = { qty: 1, discount: 0 };

    function selectedOptions() {
      return $all('.opt').map(function (opt) {
        var active = opt.querySelector('.v-btn.is-active');
        return active ? active.getAttribute('data-value') : null;
      });
    }

    function findVariant(opts) {
      if (!variants) return null;
      for (var i = 0; i < variants.length; i++) {
        var match = true;
        for (var j = 0; j < opts.length; j++) {
          if (variants[i].options[j] !== opts[j]) { match = false; break; }
        }
        if (match) return variants[i];
      }
      return null;
    }

    // Grise les valeurs d'option sans variante disponible (autres choix constants)
    function updateOptionAvailability() {
      if (!variants) return;
      var selected = selectedOptions();
      $all('.opt').forEach(function (opt, optIndex) {
        $all('.v-btn', opt).forEach(function (btn) {
          var candidate = selected.slice();
          candidate[optIndex] = btn.getAttribute('data-value');
          var available = variants.some(function (v) {
            if (!v.available) return false;
            for (var j = 0; j < candidate.length; j++) {
              if (candidate[j] !== null && v.options[j] !== candidate[j]) return false;
            }
            return true;
          });
          btn.classList.toggle('is-out', !available);
        });
      });
    }

    function updateTotals() {
      var qty = bundleState.qty;
      var discount = bundleState.discount;
      var total = Math.round(currentPrice * qty * (100 - discount) / 100);
      $all('[data-atc-total]').forEach(function (el) { el.textContent = formatMoney(total); });
      var qtyInput = $('[data-bundle-qty-input]');
      if (qtyInput) qtyInput.value = qty;
      $all('[data-bundle]').forEach(function (opt) {
        var q = parseInt(opt.getAttribute('data-qty'), 10);
        var d = parseInt(opt.getAttribute('data-discount'), 10) || 0;
        var optWas = Math.round(currentPrice * q);
        var optTotal = Math.round(optWas * (100 - d) / 100);
        var totalEl = opt.querySelector('[data-bundle-total]');
        if (totalEl) totalEl.textContent = formatMoney(optTotal);
        var wasEl = opt.querySelector('[data-bundle-was]');
        var saveEl = opt.querySelector('[data-bundle-save]');
        if (wasEl) {
          wasEl.hidden = d <= 0;
          if (d > 0) wasEl.textContent = formatMoney(optWas);
        }
        if (saveEl) {
          saveEl.hidden = d <= 0;
          if (d > 0) saveEl.textContent = 'Économisez ' + formatMoney(optWas - optTotal);
        }
      });
    }

    function applyVariant(variant) {
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      currentPrice = variant.price;
      var priceEl = $('[data-price]');
      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
        priceEl.classList.remove('is-pop');
        void priceEl.offsetWidth;
        priceEl.classList.add('is-pop');
      }
      var compareEl = $('[data-compare]');
      var saveEl = $('[data-save]');
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
          if (saveEl) {
            saveEl.textContent = 'Économisez ' + formatMoney(variant.compare_at_price - variant.price);
            saveEl.hidden = false;
          }
        } else {
          compareEl.hidden = true;
          if (saveEl) saveEl.hidden = true;
        }
      }
      var atc = $('[data-atc]');
      if (atc) {
        atc.disabled = !variant.available;
        if (!variant.available) atc.textContent = 'Épuisé';
      }
      var buyNowBtn = $('[data-buy-now]');
      if (buyNowBtn) buyNowBtn.disabled = !variant.available;
      var stickyBtnEl = $('[data-sticky-atc]');
      if (stickyBtnEl) {
        stickyBtnEl.disabled = !variant.available;
        stickyBtnEl.textContent = variant.available ? 'Ajouter au panier' : 'Épuisé';
      }
      var stock = $('[data-stock]');
      if (stock) {
        var low = variant.available && typeof variant.qty === 'number' && variant.qty > 0 && variant.qty <= 10;
        stock.hidden = !low;
        if (low) stock.textContent = 'Plus que ' + variant.qty + ' en stock';
      }
      updateTotals();
    }

    $all('.opt').forEach(function (opt) {
      $all('.v-btn', opt).forEach(function (btn) {
        btn.addEventListener('click', function () {
          $all('.v-btn', opt).forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          var current = opt.querySelector('[data-opt-current]');
          if (current) current.textContent = btn.getAttribute('data-value');
          applyVariant(findVariant(selectedOptions()));
          updateOptionAvailability();
        });
      });
    });
    updateOptionAvailability();

    // Offres par quantité
    $all('[data-bundle]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        $all('[data-bundle]').forEach(function (o) { o.classList.remove('is-active'); });
        opt.classList.add('is-active');
        bundleState.qty = parseInt(opt.getAttribute('data-qty'), 10) || 1;
        bundleState.discount = parseInt(opt.getAttribute('data-discount'), 10) || 0;
        updateTotals();
      });
    });
    updateTotals();

    // Barre d'achat collante
    var sticky = $('#sticky-atc');
    var form = $('#pdp-form');
    if (sticky && form) {
      var onScroll = function () {
        var rect = form.getBoundingClientRect();
        var show = rect.bottom < 0;
        sticky.classList.toggle('is-on', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      var stickyBtn = $('[data-sticky-atc]');
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.submit();
        });
      }
    }

    // Guide des tailles + calculateur
    var chart = [
      { size: 'XS', height: 163, weight: 52 },
      { size: 'S', height: 168, weight: 60 },
      { size: 'M', height: 174, weight: 70 },
      { size: 'L', height: 180, weight: 80 },
      { size: 'XL', height: 186, weight: 90 },
      { size: 'XXL', height: 191, weight: 102 }
    ];
    function computeSize() {
      var h = parseFloat(($('#guide-height') || {}).value);
      var w = parseFloat(($('#guide-weight') || {}).value);
      var result = $('#guide-result');
      if (!h || !w || !result) { if (result) result.classList.remove('is-on'); return; }
      var best = null, bestDist = Infinity;
      chart.forEach(function (row) {
        var dh = (h - row.height) / 6;
        var dw = (w - row.weight) / 6;
        var dist = dh * dh + dw * dw;
        if (dist < bestDist) { bestDist = dist; best = row.size; }
      });
      $('#guide-size').textContent = best;
      result.classList.add('is-on');
    }
    ['#guide-height', '#guide-weight'].forEach(function (sel) {
      var input = $(sel);
      if (input) input.addEventListener('input', computeSize);
    });
    $all('[data-guide-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var modal = $('#size-guide');
        if (modal && !modal.classList.contains('is-on')) {
          modal.classList.add('is-on');
          lockScroll();
          var firstField = modal.querySelector('input');
          if (firstField) firstField.focus();
        }
      });
    });

    // Guide des tailles : onglets Vêtements / Chaussures
    function showGuideTab(key) {
      $all('[data-guide-tab]').forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-guide-tab') === key); });
      $all('[data-guide-pane]').forEach(function (p) { p.hidden = p.getAttribute('data-guide-pane') !== key; });
    }
    $all('[data-guide-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () { showGuideTab(tab.getAttribute('data-guide-tab')); });
    });
    var guideTabs = $('.guide-tabs');
    if (guideTabs) showGuideTab(guideTabs.getAttribute('data-guide-default') || 'apparel');

    // Calculateur de pointure
    var shoeChart = [
      [36, 22.5, '5,5', '3,5'], [37, 23.5, '6,5', '4'], [38, 24, '7', '5'],
      [39, 24.5, '8', '5,5'], [40, 25.5, '8,5', '6,5'], [41, 26, '9,5', '7'],
      [42, 26.5, '10', '8'], [43, 27.5, '10,5', '9'], [44, 28, '11,5', '9,5'], [45, 29, '12', '10,5']
    ];
    var footInput = $('#guide-foot');
    if (footInput) {
      footInput.addEventListener('input', function () {
        var cm = parseFloat(footInput.value);
        var result = $('#guide-shoe-result');
        if (!cm || cm < 20 || cm > 32 || !result) { if (result) result.classList.remove('is-on'); return; }
        var best = shoeChart[0], bestDiff = Infinity;
        shoeChart.forEach(function (row) {
          var diff = Math.abs(cm - row[1]);
          if (diff < bestDiff) { bestDiff = diff; best = row; }
        });
        $('#guide-shoe-size').textContent = 'EU ' + best[0];
        $('#guide-shoe-note').textContent = 'US ' + best[2] + ' · UK ' + best[3] + ' — pointure indicative. Pour les modèles chunky, prenez une demi-pointure au-dessus.';
        result.classList.remove('is-on');
        void result.offsetWidth;
        result.classList.add('is-on');
      });
    }

    // Estimation de livraison, avec heure limite d'expédition le jour même
    var delivery = $('[data-delivery-range]');
    if (delivery) {
      var minDays = parseInt(delivery.getAttribute('data-min'), 10) || 5;
      var maxDays = parseInt(delivery.getAttribute('data-max'), 10) || 10;
      var cutoffEl = $('[data-delivery-cutoff]');
      var cutoffHour = cutoffEl ? parseInt(cutoffEl.getAttribute('data-hour'), 10) || 20 : 20;
      var now = new Date();
      var beforeCutoff = now.getHours() < cutoffHour;
      var base = beforeCutoff ? Date.now() : Date.now() + 86400000;
      var fmt = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'long' });
      var from = new Date(base + minDays * 86400000);
      var to = new Date(base + maxDays * 86400000);
      delivery.textContent = 'entre le ' + fmt.format(from) + ' et le ' + fmt.format(to);
      if (cutoffEl) {
        if (beforeCutoff) {
          var mins = (cutoffHour * 60) - (now.getHours() * 60 + now.getMinutes());
          var h = Math.floor(mins / 60);
          var m = mins % 60;
          cutoffEl.textContent = 'Expédié aujourd’hui si vous commandez dans ' + (h > 0 ? h + ' h ' : '') + m + ' min';
        } else {
          cutoffEl.textContent = 'Expédié dès demain matin';
        }
      }
    }
    $all('[data-guide-close]').forEach(function (btn) { btn.addEventListener('click', closeGuide); });
    var guideModal = $('#size-guide');
    if (guideModal) {
      guideModal.addEventListener('click', function (e) {
        if (e.target === guideModal) closeGuide();
      });
    }
  }
  function closeGuide() {
    var modal = $('#size-guide');
    if (modal && modal.classList.contains('is-on')) {
      modal.classList.remove('is-on');
      unlockScroll();
    }
  }

  /* ---------- Compte à rebours 24 h (localStorage glissant) ---------- */
  var cd = $('[data-countdown]');
  if (cd) {
    var expiry = parseInt(storageGet('wise_promo_expiry'), 10);
    var now = Date.now();
    if (!expiry || isNaN(expiry) || expiry <= now) {
      expiry = now + 24 * 3600 * 1000;
      storageSet('wise_promo_expiry', String(expiry));
    }
    var hEl = $('[data-cd-h]', cd), mEl = $('[data-cd-m]', cd), sEl = $('[data-cd-s]', cd);
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
    var tick = function () {
      var remaining = Math.max(0, Math.round((expiry - Date.now()) / 1000));
      if (remaining <= 0) {
        expiry = Date.now() + 24 * 3600 * 1000;
        storageSet('wise_promo_expiry', String(expiry));
        remaining = 24 * 3600;
      }
      if (hEl) hEl.textContent = pad(Math.floor(remaining / 3600));
      if (mEl) mEl.textContent = pad(Math.floor((remaining % 3600) / 60));
      if (sEl) sEl.textContent = pad(remaining % 60);
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Avis : défilement horizontal ---------- */
  var revScroll = $('#rev-scroll');
  if (revScroll) {
    var prev = $('[data-rev-prev]');
    var next = $('[data-rev-next]');
    if (prev) prev.addEventListener('click', function () { revScroll.scrollBy({ left: -320, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { revScroll.scrollBy({ left: 320, behavior: 'smooth' }); });
  }

  /* ---------- FAQ : recherche, surlignage, puces-filtres, accordéons ---------- */
  var faq = $('[data-faq]');
  if (faq) {
    var faqGroups = $all('[data-faq-group]', faq);
    var faqActiveGroup = -1;

    $all('.faq__q', faq).forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.parentElement;
        var open = item.classList.toggle('is-open');
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          var group = item.closest('[data-faq-group]');
          if (group) {
            $all('.faq__i.is-open', group).forEach(function (other) {
              if (other === item) return;
              other.classList.remove('is-open');
              var ob = $('.faq__q', other);
              if (ob) ob.setAttribute('aria-expanded', 'false');
            });
          }
        }
      });
    });

    function faqEscHtml(s) { return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
    function faqEscRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

    var chips = $('#faq-chips');
    var countEl = $('#faq-count');
    var search = $('#faq-search');

    function updateChips() {
      if (!chips) return;
      var html = '<button type="button" class="faq-chip' + (faqActiveGroup === -1 ? ' is-active' : '') + '" data-chip="-1">Toutes</button>';
      html += faqGroups.map(function (group, gi) {
        var title = ($('[data-faq-group-title]', group) || {}).textContent || '';
        var count = $all('[data-faq-item]', group).length;
        var cEl = $('[data-faq-group-count]', group);
        if (cEl) cEl.textContent = count + (count === 1 ? ' question' : ' questions');
        return '<button type="button" class="faq-chip' + (faqActiveGroup === gi ? ' is-active' : '') + '" data-chip="' + gi + '">' + faqEscHtml(title) + ' · ' + count + '</button>';
      }).join('');
      chips.innerHTML = html;
      $all('.faq-chip', chips).forEach(function (chip) {
        chip.addEventListener('click', function () {
          var gi = parseInt(chip.getAttribute('data-chip'), 10);
          faqActiveGroup = (gi === faqActiveGroup) ? -1 : gi;
          if (search) search.value = '';
          filterFaq();
        });
      });
    }

    function filterFaq() {
      var q = (search ? search.value : '').trim().toLowerCase();
      if (q) faqActiveGroup = -1;
      var any = false;
      var total = 0;
      var re = q ? new RegExp('(' + faqEscRe(q) + ')', 'gi') : null;
      faqGroups.forEach(function (group, gi) {
        var visible = 0;
        $all('[data-faq-item]', group).forEach(function (item) {
          var txtEl = $('[data-faq-q-txt]', item);
          if (txtEl && !item.hasAttribute('data-faq-orig')) item.setAttribute('data-faq-orig', txtEl.textContent);
          var orig = item.getAttribute('data-faq-orig') || '';
          var show = (!q || item.textContent.toLowerCase().indexOf(q) !== -1) && (faqActiveGroup === -1 || faqActiveGroup === gi);
          item.style.display = show ? '' : 'none';
          if (txtEl) txtEl.innerHTML = (show && re) ? faqEscHtml(orig).replace(re, '<mark>$1</mark>') : faqEscHtml(orig);
          if (show) visible++;
        });
        group.style.display = visible ? '' : 'none';
        if (visible) { any = true; total += visible; }
      });
      var none = $('#faq-none');
      if (none) none.style.display = any ? 'none' : 'block';
      if (countEl) countEl.textContent = total + (total === 1 ? ' réponse' : ' réponses');
      updateChips();
    }

    if (search) search.addEventListener('input', filterFaq);
    $all('[data-faq-chat]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var launcher = $('#chat-btn');
        if (launcher) launcher.click();
      });
    });
    filterFaq();
  }

  /* ---------- Suivi de commande ---------- */
  var carriersWrap = $('#carriers');
  if (carriersWrap) {
    var carrierName = $('#track-carrier-name');
    $all('.carrier', carriersWrap).forEach(function (btn) {
      btn.addEventListener('click', function () {
        $all('.carrier', carriersWrap).forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        if (carrierName) carrierName.textContent = btn.textContent.trim();
      });
    });
    var go = $('#track-go');
    if (go) {
      go.addEventListener('click', function () {
        var num = ($('#track-number') || {}).value;
        if (!num || !num.trim()) return;
        var active = $('.carrier.is-active', carriersWrap);
        var base = active ? active.getAttribute('data-url') : null;
        if (base) window.open(base + encodeURIComponent(num.trim()), '_blank', 'noopener');
      });
    }
  }

  /* ---------- Code promo enregistré (compte → panier) ---------- */
  var PROMO_KEY = 'wise_saved_promo';
  function getSavedPromo() { return storageGet(PROMO_KEY) || ''; }
  function renderSavedPromo() {
    var code = getSavedPromo();
    var savedBox = $('[data-promo-saved]');
    var emptyBox = $('[data-promo-empty]');
    if (savedBox && emptyBox) {
      savedBox.hidden = !code;
      emptyBox.hidden = !!code;
      var codeEl = $('[data-promo-code]');
      if (codeEl) codeEl.textContent = code;
    }
    var cartInput = $('#promo-code');
    if (cartInput && code && !cartInput.value) cartInput.value = code;
  }
  function setSavedPromo(code) {
    if (code) storageSet(PROMO_KEY, code);
    else { try { window.localStorage.removeItem(PROMO_KEY); } catch (e) {} }
    renderSavedPromo();
  }
  var promoSave = $('[data-promo-save]');
  if (promoSave) {
    promoSave.addEventListener('click', function () {
      var input = $('#acct-promo-input');
      var code = input && input.value.trim().toUpperCase();
      if (code) setSavedPromo(code);
    });
  }
  var promoRemove = $('[data-promo-remove]');
  if (promoRemove) promoRemove.addEventListener('click', function () { setSavedPromo(''); });
  renderSavedPromo();

  /* ---------- Roue des récompenses (un seul lot par appareil) ----------
     Remplace intégralement le bloc wise.js lignes ~783 à ~925.
     buildEdge() disparaît : le relief ne vient plus d'une pile de disques
     mais de la séparation des plans en profondeur.                        */
  var WHEEL_KEY = 'wise_wheel_prize';
  var wheelSpin = $('#wheel-spin');
  if (wheelSpin) {
    var dial  = $('#wheel-dial');
    var stage = $('#wheel-stage');
    var zone  = document.querySelector('.wheel-zone');
    var scene = document.querySelector('.wheel-scene');
    var index = document.querySelector('.wheel-index');
    var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    /* --- Solveur de courbe de Bézier : l'animation est pilotée en rAF,
           ce qui permet de faire tressaillir l'index à chaque frontière
           sans jamais relire le style calculé pendant l'animation. --- */
    function bezier(x1, y1, x2, y2) {
      function A(a, b) { return 1 - 3 * b + 3 * a; }
      function B(a, b) { return 3 * b - 6 * a; }
      function C(a) { return 3 * a; }
      function val(t, a, b) { return ((A(a, b) * t + B(a, b)) * t + C(a)) * t; }
      function slope(t, a, b) { return 3 * A(a, b) * t * t + 2 * B(a, b) * t + C(a); }
      return function (x) {
        if (x <= 0) return 0;
        if (x >= 1) return 1;
        var t = x;
        for (var i = 0; i < 8; i++) {
          var d = slope(t, x1, x2);
          if (Math.abs(d) < 1e-6) break;
          var e = val(t, x1, x2) - x;
          if (Math.abs(e) < 1e-5) break;
          t -= e / d;
        }
        return val(t, y1, y2);
      };
    }
    var easeSpin = bezier(0.17, 0.67, 0.10, 1);

    /* --- Le texte des segments suit la courbe de l'anneau.
           Amélioration progressive : sans JS, les libellés restent posés à
           plat par le Liquid et demeurent parfaitement lisibles. --- */
    /* --- Le texte suit la courbe de l'anneau, et se remet à l'endroit
           à chaque arrêt de la roue : un libellé qui finit dans la moitié
           basse est retourné pour rester lisible. Sans JS, les libellés
           restent posés à plat par le Liquid. --- */
    var labelLayouts = [];
    function applyLabels(offset) {
      labelLayouts.forEach(function (L) {
        var eff = (((L.mid + offset) % 360) + 360) % 360;
        var flip = eff > 90 && eff < 270;
        if (!L.arc) {
          L.label.style.setProperty('--flip', flip ? '180deg' : '0deg');
          return;
        }
        var cursor = -L.total / 2;
        var frag = document.createDocumentFragment();
        L.chars.forEach(function (c, k) {
          var el = document.createElement('span');
          el.textContent = c;
          var da = ((cursor + L.widths[k] / 2) / L.radius) * L.DEG;
          el.style.setProperty('--ca', (flip ? L.mid - da : L.mid + da).toFixed(3) + 'deg');
          if (flip) el.style.setProperty('--cf', '180deg');
          frag.appendChild(el);
          cursor += L.widths[k];
        });
        while (L.label.firstChild) L.label.removeChild(L.label.firstChild);
        L.label.appendChild(frag);
        L.label.classList.add('is-arc');
      });
    }
    (function prepareLabels() {
      if (!dial || !zone) return;
      var labels = dial.querySelectorAll('.wheel-label');
      if (!labels.length) return;
      var first = labels[0].querySelector('span');
      if (!first) return;

      var zs = getComputedStyle(zone);
      var radius = parseFloat(zs.getPropertyValue('--r')) || 108;
      var segAngle = parseFloat(zs.getPropertyValue('--seg')) || (360 / labels.length);
      if (!radius || !segAngle) return;

      var ctx = document.createElement('canvas').getContext('2d');
      if (!ctx) return;
      var ls = getComputedStyle(first);
      ctx.font = ls.fontStyle + ' ' + ls.fontWeight + ' ' + ls.fontSize + ' ' + ls.fontFamily;
      var tracking = parseFloat(ls.letterSpacing) || 0;
      var DEG = 180 / Math.PI;

      Array.prototype.forEach.call(labels, function (label) {
        var span = label.querySelector('span');
        if (!span) return;
        var raw = (span.textContent || '').trim();
        if (!raw) return;
        var mid = parseFloat(label.style.getPropertyValue('--a')) || 0;
        var chars = raw.split('');
        var widths = chars.map(function (c) { return ctx.measureText(c.toUpperCase()).width + tracking; });
        var total = widths.reduce(function (a, b) { return a + b; }, 0);
        var arcAngle = (total / radius) * DEG;
        var arc = !!total && arcAngle <= segAngle * 0.82;
        if (arc) label.setAttribute('data-label', raw);
        labelLayouts.push({ label: label, mid: mid, chars: chars, widths: widths, total: total, radius: radius, DEG: DEG, arc: arc });
      });
      applyLabels(0);
    })();

    var dataScript = $('#wheel-data');
    var prizes = dataScript ? JSON.parse(dataScript.textContent) : [];
    var spinning = false;
    var angle = 0; // angle courant du disque, en degrés

    function nudgeIndex() {
      if (!index || reduceMotion) return;
      index.classList.add('is-tick');
      clearTimeout(index._tick);
      index._tick = setTimeout(function () { index.classList.remove('is-tick'); }, 110);
    }

    /* Trois temps : appel (léger recul), course longue, repos élastique. */
    var SPIN_MS = 5200, WIND_MS = 260, SETTLE_MS = 420;
    function runSpin(from, to, done) {
      if (reduceMotion) {
        angle = to;
        dial.style.transform = 'rotate(' + to + 'deg)';
        setTimeout(done, 320);
        return;
      }
      var seg = 360 / (prizes.length || 1);
      var back = from - 6;
      var t0 = 0;
      var lastTick = Math.floor(from / seg);
      dial.classList.add('is-spinning');

      function frame(ts) {
        if (!t0) t0 = ts;
        var e = ts - t0, a;
        if (e < WIND_MS) {
          a = from + (back - from) * (e / WIND_MS);
        } else if (e < WIND_MS + SPIN_MS) {
          a = back + (to - back) * easeSpin((e - WIND_MS) / SPIN_MS);
        } else if (e < WIND_MS + SPIN_MS + SETTLE_MS) {
          var s = (e - WIND_MS - SPIN_MS) / SETTLE_MS;
          a = to + 1.1 * Math.sin(s * Math.PI) * (1 - s);
        } else {
          dial.style.transform = 'rotate(' + to + 'deg)';
          dial.classList.remove('is-spinning');
          angle = to;
          done();
          return;
        }
        dial.style.transform = 'rotate(' + a.toFixed(3) + 'deg)';
        var tick = Math.floor(a / seg);
        if (tick !== lastTick) { lastTick = tick; nudgeIndex(); }
        requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    /* --- Parallaxe : les plans glissent les uns contre les autres.
           Souris fine uniquement, jamais au tactile, jamais en mouvement réduit. --- */
    (function parallax() {
      if (!scene || !stage || reduceMotion) return;
      if (!(window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches)) return;
      var rect = null, queued = false, mx = 0, my = 0;
      function apply() {
        queued = false;
        if (!rect || spinning) return;
        stage.style.setProperty('--yaw', (mx * 7).toFixed(2) + 'deg');
        stage.style.setProperty('--tilt', (18 - my * 6).toFixed(2) + 'deg');
      }
      scene.addEventListener('pointerenter', function () {
        if (spinning) return;
        rect = scene.getBoundingClientRect();
        stage.classList.add('is-tilting');
      });
      scene.addEventListener('pointermove', function (ev) {
        if (!rect || spinning) return;
        mx = (ev.clientX - rect.left) / rect.width - 0.5;
        my = (ev.clientY - rect.top) / rect.height - 0.5;
        if (!queued) { queued = true; requestAnimationFrame(apply); }
      });
      scene.addEventListener('pointerleave', function () {
        rect = null;
        stage.classList.remove('is-tilting');
        stage.style.removeProperty('--yaw');
        stage.style.removeProperty('--tilt');
      });
      window.addEventListener('resize', function () { rect = null; });
    })();

    function showWheelResult(prize) {
      var result = $('#wheel-result');
      var title  = $('#wheel-result-title');
      var text   = $('#wheel-result-text');
      var code   = $('#wheel-result-code');
      if (title) title.textContent = prize.label;
      if (text) text.textContent = prize.desc || '';
      if (code) {
        if (prize.code) { code.textContent = prize.code; code.hidden = false; }
        else { code.hidden = true; }
      }
      if (result) result.classList.add('is-on');
    }
    function lockWheel(lost) {
      wheelSpin.disabled = true;
      wheelSpin.textContent = lost ? 'Pas de lot cette fois' : 'Lot déjà gagné';
      var note = $('.wheel-locked');
      if (!note) {
        note = document.createElement('p');
        note.className = 'wheel-locked';
        wheelSpin.insertAdjacentElement('afterend', note);
      }
      note.textContent = lost
        ? 'La chance n’était pas au rendez-vous cette fois.'
        : 'Votre lot est enregistré ci-dessous.';
    }

    // Nombre de tours autorisés, défini par le gabarit.
    var allowed = parseInt(wheelSpin.getAttribute('data-allowed'), 10) || 1;
    var spinsNote = $('#wheel-spins');

    function readState() {
      var raw = null;
      try { raw = JSON.parse(storageGet(WHEEL_KEY) || 'null'); } catch (e) {}
      if (!raw) return { used: 0, last: null };
      if (raw.label !== undefined) return { used: 1, last: raw };
      return { used: raw.used || 0, last: raw.last || null };
    }
    function writeState(state) {
      storageSet(WHEEL_KEY, JSON.stringify({ used: state.used, last: state.last }));
    }
    function updateSpinsNote(left) {
      if (!spinsNote) return;
      if (left > 0) {
        spinsNote.textContent = left === 1 ? 'Il vous reste 1 tour.' : 'Il vous reste ' + left + ' tours.';
      } else {
        spinsNote.textContent = 'Votre tour a été joué.';
      }
    }

    var state = readState();
    if (state.last) showWheelResult(state.last);
    if (state.used >= allowed) lockWheel(state.last && state.last.lose);
    updateSpinsNote(allowed - state.used);

    wheelSpin.addEventListener('click', function () {
      if (spinning || wheelSpin.disabled || !dial || !prizes.length) return;
      state = readState();
      if (state.used >= allowed) { lockWheel(state.last && state.last.lose); return; }

      spinning = true;
      wheelSpin.disabled = true;
      if (stage) {
        // La parallaxe rend la main : le plateau se redresse pour se donner à lire.
        stage.classList.remove('is-tilting');
        stage.style.removeProperty('--yaw');
        stage.style.removeProperty('--tilt');
        stage.classList.add('is-spinning');
      }
      var result = $('#wheel-result');
      if (result) result.classList.remove('is-on');

      var idx = Math.floor(Math.random() * prizes.length);
      var seg = 360 / prizes.length;
      // Point d'arrivée sous l'index, avec un léger décentrage naturel.
      var landing = 360 - idx * seg - seg / 2 + (Math.random() - 0.5) * seg * 0.44;
      var delta = (((landing - angle) % 360) + 360) % 360;
      var target = angle + delta + 360 * 6;

      runSpin(angle, target, function () {
        spinning = false;
        applyLabels(angle);
        if (stage) stage.classList.remove('is-spinning');
        var prize = prizes[idx];
        var record = { label: prize.label, desc: prize.desc, code: prize.code, lose: !!prize.lose, at: Date.now() };
        showWheelResult(prize);
        if (prize.code) {
          // Lot gagné : le tour est consommé et le code enregistré.
          state.used += 1;
          state.last = record;
          writeState(state);
          setSavedPromo(prize.code);
          updateSpinsNote(allowed - state.used);
          if (state.used >= allowed) lockWheel(false);
          else { wheelSpin.disabled = false; wheelSpin.textContent = 'Tourner à nouveau'; }
        } else if (prize.lose) {
          // Perdu : le tour est bien consommé, aucun lot enregistré.
          state.used += 1;
          state.last = record;
          writeState(state);
          announce('Pas de lot cette fois');
          updateSpinsNote(allowed - state.used);
          if (state.used >= allowed) lockWheel(true);
          else { wheelSpin.disabled = false; wheelSpin.textContent = 'Tourner à nouveau'; }
        } else {
          // Relance offerte : le tour n'est pas décompté.
          wheelSpin.disabled = false;
          wheelSpin.textContent = 'Retenter ma chance';
        }
      });
    });

    // Copie du code gagné au clic
    var wheelCode = $('#wheel-result-code');
    if (wheelCode) {
      wheelCode.setAttribute('title', 'Cliquer pour copier');
      wheelCode.style.cursor = 'copy';
      wheelCode.addEventListener('click', function () {
        var code = wheelCode.getAttribute('data-code') || wheelCode.textContent.trim();
        if (!code || !navigator.clipboard) return;
        wheelCode.setAttribute('data-code', code);
        navigator.clipboard.writeText(code).then(function () {
          wheelCode.textContent = 'Copié !';
          announce('Code promo copié');
          setTimeout(function () { wheelCode.textContent = code; }, 1400);
        }).catch(function () {});
      });
    }
  }

  /* ---------- Popup de bienvenue ---------- */
  var pop = $('#pop');
  function closePopup() {
    if (!pop || pop.hidden) return;
    pop.classList.remove('is-on');
    pop.hidden = true;
    unlockScroll();
    storageSet('wise_welcome_popup_seen', '1');
  }
  if (pop) {
    if (!storageGet('wise_welcome_popup_seen')) {
      setTimeout(function () {
        pop.hidden = false;
        lockScroll();
        requestAnimationFrame(function () {
          pop.classList.add('is-on');
          var popClose = pop.querySelector('[data-pop-close]');
          if (popClose) popClose.focus();
        });
      }, 5000);
    }
    $all('[data-pop-close]', pop).forEach(function (btn) { btn.addEventListener('click', closePopup); });
    pop.addEventListener('click', function (e) { if (e.target === pop) closePopup(); });
  }

  /* ---------- Assistant Wise : compréhension locale + catalogue en direct ----------
     Aucun serveur, aucune clé : la compréhension est un moteur de
     correspondance floue embarqué (fautes de frappe tolérées) et les
     questions produit interrogent le catalogue réel via l'API de
     suggestion native de la boutique. ---------- */
  var chat = $('#chat');
  if (chat) {
    var chatBtn = $('#chat-btn');
    var chatWin = $('#chat-win');
    var chatMsgs = $('#chat-msgs');
    var greeted = false;

    function chatNorm(value) {
      value = (value || '').toLowerCase();
      if (value.normalize) value = value.normalize('NFD').replace(/[̀-ͯ]/g, '');
      return value.replace(/[^a-z0-9\s-]/g, ' ').replace(/\s+/g, ' ').trim();
    }
    /* Distance d'édition bornée : 1 faute tolérée dès 4 lettres, 2 dès 7. */
    function levOk(a, b) {
      if (a === b) return true;
      var la = a.length, lb = b.length;
      if (la < 4 || Math.abs(la - lb) > 2) return false;
      var max = la >= 7 ? 2 : 1;
      var prev = [], cur = [], i, k;
      for (k = 0; k <= lb; k++) prev[k] = k;
      for (i = 1; i <= la; i++) {
        cur[0] = i;
        var best = i;
        for (k = 1; k <= lb; k++) {
          cur[k] = Math.min(prev[k] + 1, cur[k - 1] + 1, prev[k - 1] + (a[i - 1] === b[k - 1] ? 0 : 1));
          if (cur[k] < best) best = cur[k];
        }
        if (best > max) return false;
        prev = cur.slice();
      }
      return prev[lb] <= max;
    }

    var CHAT_STOP = ' le la les un une des de du d au aux a et ou en est sur pour avec sans dans par mon ma mes ta votre vos je tu il elle on nous vous ils que qui quoi comment combien quand pourquoi ca cela puis peux peut faut il-y-a y as ai avez avoir etre suis sont c ce cette ces sa son ses se ne pas plus tres bien bonjour bonsoir salut merci svp stp donc alors si mais aussi encore chez vers moi toi do you have has the is are can could would i we what where when how much many please an of to for with my your it this that there any and or does did want need some ';
    function chatTokens(value) {
      return chatNorm(value).split(' ').filter(function (t) {
        if (!t) return false;
        if (/^\d{1,4}$/.test(t)) return true;
        return t.length > 1 && CHAT_STOP.indexOf(' ' + t + ' ') < 0;
      });
    }

    /* La base de connaissances : mots simples (2 pts exact, 1 pt avec faute),
       expressions (4 pts). Le meilleur score répond ; sous 2, on cherche au
       catalogue puis on avoue ne pas savoir. */
    /* La base de connaissances vit dans wise-brain.js (chargé avant ce
       fichier) : 116 sujets bilingues, plus de 500 questions couvertes. */
    var INTENTS = window.WISE_INTENTS || [];
    var ANSWERS_BY_KEY = {};
    INTENTS.forEach(function (it) { ANSWERS_BY_KEY[it.key] = it; });

    function chatLang() {
      return ((document.documentElement.lang||'fr').toLowerCase().slice(0,2)==='en'?'en':((document.documentElement.lang||'fr').toLowerCase().slice(0,2)==='es'?'es':'fr'));
    }
    /* Une intention devient une réponse dans la langue de l'interface. */
    function intentPayload(intent) {
      if (chatLang() === 'en' && intent.en) {
        return {
          text: intent.en,
          link: intent.link ? { href: intent.link.href, label: intent.len || intent.link.label } : null
        };
      }
      if (chatLang() === 'es' && intent.es) { return { text: intent.es, link: intent.link ? { href: intent.link.href, label: intent.les || intent.link.label } : null }; }
    return { text: intent.text, link: intent.link || null };
    }
    var CHAT_UI = {
      fr: {
        greet: 'Bonjour, bienvenue chez Wise ! Posez votre question librement — je peux aussi chercher un article : essayez « vous avez des Jordan 4 ? »',
        found_one: 'J’ai trouvé ceci au catalogue :',
        found_many: 'Voici ce que j’ai trouvé au catalogue :',
        see_all: 'Voir tous les résultats',
        none: 'Je n’ai rien trouvé au catalogue sous ce nom. Essayez un autre mot (marque, type de pièce), ou parcourez les univers.',
        browse: 'Explorer les catégories',
        fallback: 'Je n’ai pas la réponse exacte sous la main. Reformulez en un mot-clé (livraison, retour, taille, box, parrainage…), demandez-moi un article, ou écrivez-nous sur WhatsApp : réponse en direct, 7 j/7.',
        contact: 'Nous contacter',
        wa: 'Écrivez-nous sur WhatsApp, on vous répond en direct.'
      },
      en: {
        greet: 'Hello, welcome to Wise! Ask me anything — I can also search the catalogue: try “do you have Jordan 4s?”',
        found_one: 'I found this in the catalogue:',
        found_many: 'Here is what I found in the catalogue:',
        see_all: 'See all results',
        none: 'I could not find anything under that name. Try another word (brand, type of piece), or browse the universes.',
        browse: 'Browse the categories',
        fallback: 'I do not have that exact answer at hand. Try a keyword (delivery, return, size, box, referral…), ask me for a product, or write to us on WhatsApp: live replies, 7 days a week.',
        contact: 'Contact us',
        wa: 'Write to us on WhatsApp for a live reply.'
      },
      es: {
        greet: 'Hola, ¡bienvenido a Wise! Pregúntame lo que quieras — también puedo buscar un artículo: prueba «¿tienes Jordan 4?»',
        found_one: 'He encontrado esto en el catálogo:',
        found_many: 'Esto es lo que he encontrado en el catálogo:',
        see_all: 'Ver todos los resultados',
        none: 'No he encontrado nada con ese nombre. Prueba con otra palabra (marca, tipo de pieza) o explora los mundos.',
        browse: 'Explorar las categorías',
        fallback: 'No tengo la respuesta exacta a mano. Prueba con una palabra clave (envío, devolución, talla, caja, referidos…), pídeme un artículo o escríbenos por WhatsApp: respuesta en directo, 7 días a la semana.',
        contact: 'Contáctanos',
        wa: 'Escríbenos por WhatsApp y te respondemos en directo.'
      }
    };
    function chatUi(key) { return CHAT_UI[chatLang()][key]; }

    /* Vocabulaire produit : s'il apparaît, on interroge le vrai catalogue. */
    var PRODUCT_WORDS = ['nike', 'jordan', 'adidas', 'dior', 'chanel', 'gucci', 'vuitton', 'louis', 'balenciaga', 'burberry', 'fendi', 'hermes', 'goyard', 'moncler', 'lacoste', 'stone', 'island', 'ralph', 'lauren', 'yeezy', 'ugg', 'asics', 'balance', 'samba', 'campus', 'dunk', 'terrascape', 'trainer', 'jacquemus', 'swarovski', 'trapstar', 'pyrenex', 'parajumpers', 'kurkdjian', 'mihara', 'sneaker', 'sneakers', 'basket', 'baskets', 'chaussure', 'chaussures', 'sacoche', 'sac', 'sacs', 'casquette', 'bonnet', 'bob', 'collier', 'bracelet', 'bague', 'lunette', 'lunettes', 'doudoune', 'veste', 'pull', 'sweat', 'short', 'claquette', 'claquettes', 'tee', 'shirt', 'parfum', 'parfums', 'maillot', 'cardigan', 'b22', 'b30', 'p6000', 'tn'];

    function scoreIntent(intent, flat, tokens) {
      var score = 0, i, k;
      for (i = 0; i < intent.phrases.length; i++) {
        if (flat.indexOf(intent.phrases[i]) >= 0) score += 4;
      }
      for (i = 0; i < tokens.length; i++) {
        var exact = false;
        for (k = 0; k < intent.words.length; k++) {
          if (tokens[i] === intent.words[k]) { score += 2; exact = true; break; }
        }
        if (exact) continue;
        for (k = 0; k < intent.words.length; k++) {
          if (levOk(tokens[i], intent.words[k])) { score += 1; break; }
        }
      }
      return score;
    }
    function isProductWord(token) {
      for (var k = 0; k < PRODUCT_WORDS.length; k++) {
        if (token === PRODUCT_WORDS[k] || levOk(token, PRODUCT_WORDS[k])) return true;
      }
      return false;
    }
    /* Seuls les mots produit et les références (4, b22, 1906r…) partent en
       recherche : « do you have jordan 4 » cherche « jordan 4 ». */
    function productTerms(tokens) {
      var terms = tokens.filter(function (t) {
        return isProductWord(t) || /^\d{1,4}$/.test(t) || /^[a-z]\d{1,4}r?$/.test(t);
      });
      return terms;
    }
    function searchCatalog(terms, done) {
      var url = '/search/suggest.json?q=' + encodeURIComponent(terms.join(' ')) +
        '&resources[type]=product&resources[limit]=3&resources[options][unavailable_products]=hide';
      fetch(url).then(function (r) { return r.json(); }).then(function (d) {
        done((((d || {}).resources || {}).results || {}).products || [], terms);
      }).catch(function () { done([], terms); });
    }

    function routeBot(raw, reply) {
      var flat = chatNorm(raw);
      var tokens = chatTokens(raw);
      var best = null, bestScore = 0;
      INTENTS.forEach(function (intent) {
        var s = scoreIntent(intent, flat, tokens);
        if (s > bestScore) { bestScore = s; best = intent; }
      });
      var prodTokens = productTerms(tokens);
      var produit = prodTokens.some(isProductWord);

      if (best && bestScore >= 4) return reply(intentPayload(best));
      if (produit) {
        return searchCatalog(prodTokens, function (items, terms) {
          if (items.length) {
            return reply({
              text: items.length === 1 ? chatUi('found_one') : chatUi('found_many'),
              products: items,
              link: { href: '/search?q=' + encodeURIComponent(terms.join(' ')), label: chatUi('see_all') }
            });
          }
          if (best && bestScore >= 2) return reply(intentPayload(best));
          reply({ text: chatUi('none'), link: { href: '/collections', label: chatUi('browse') } });
        });
      }
      if (best && bestScore >= 2) return reply(intentPayload(best));
      reply({ text: chatUi('fallback'), link: { href: '/pages/contact', label: chatUi('contact') } });
    }

    function escBot(value) {
      return String(value).replace(/[&<>"]/g, function (ch) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch];
      });
    }
    function chatTime() {
      var d = new Date();
      return (d.getHours() < 10 ? '0' : '') + d.getHours() + ':' + (d.getMinutes() < 10 ? '0' : '') + d.getMinutes();
    }
    function pushMsg(payload, mine) {
      if (!chatMsgs) return;
      var row = document.createElement('div');
      row.className = 'chat__row' + (mine ? ' chat__row--me' : '');
      var html = '';
      if (!mine) html += '<span class="chat__mini-av">W</span>';
      html += '<div><div class="chat__m">' + (mine ? escBot(payload.text) : payload.text);
      if (payload.products && payload.products.length) {
        html += '<span class="chat__prods">';
        payload.products.forEach(function (prod) {
          var img = prod.image || (prod.featured_image && prod.featured_image.url) || '';
          html += '<a class="chat__prod" href="' + escBot(prod.url || '#') + '">' +
            (img ? '<img src="' + escBot(img) + '" alt="" loading="lazy">' : '') +
            '<span><span class="chat__prod-t">' + escBot(prod.title || '') + '</span>' +
            (prod.price ? '<span class="chat__prod-p">' + escBot(prod.price) + ' €</span>' : '') +
            '</span></a>';
        });
        html += '</span>';
      }
      if (payload.link) html += '<br><a class="chat__m-link" href="' + payload.link.href + '">' + payload.link.label + ' →</a>';
      html += '</div><div class="chat__time"' + (mine ? ' style="text-align:right"' : '') + '>' + chatTime() + '</div></div>';
      row.innerHTML = html;
      chatMsgs.appendChild(row);
      chatMsgs.scrollTop = chatMsgs.scrollHeight;
    }
    function botReply(payload, delay) {
      var typing = document.createElement('div');
      typing.className = 'chat__row';
      typing.innerHTML = '<span class="chat__mini-av">W</span><div class="chat__typing"><i></i><i></i><i></i></div>';
      chatMsgs.appendChild(typing);
      chatMsgs.scrollTop = chatMsgs.scrollHeight;
      setTimeout(function () {
        typing.remove();
        pushMsg(payload, false);
      }, delay || 900);
    }
    if (chatBtn) {
      chatBtn.addEventListener('click', function () {
        var open = chatWin.classList.toggle('is-on');
        chat.classList.toggle('is-open', open);
        chatBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          var ask = $('#chat-ask-input');
          if (ask) setTimeout(function () { ask.focus(); }, 320);
          if (!greeted) {
            greeted = true;
            botReply({ text: chatUi('greet'), link: null }, 700);
          }
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && chatWin.classList.contains('is-on')) {
          chatWin.classList.remove('is-on');
          chat.classList.remove('is-open');
          chatBtn.setAttribute('aria-expanded', 'false');
          chatBtn.focus();
        }
      });
    }
    $all('[data-chat]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-chat');
        pushMsg({ text: btn.textContent.trim(), link: null }, true);
        botReply(ANSWERS_BY_KEY[key] ? intentPayload(ANSWERS_BY_KEY[key]) : { text: chatUi('wa'), link: null });
      });
    });
    var askForm = $('#chat-ask');
    if (askForm) {
      askForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = $('#chat-ask-input');
        if (!input) return;
        var raw = input.value.trim();
        if (!raw) return;
        input.value = '';
        pushMsg({ text: raw, link: null }, true);
        routeBot(raw, function (payload) {
          botReply(payload, 650 + Math.floor(Math.random() * 450));
        });
      });
    }
  }

  /* ---------- Preuve sociale : un achat mis en avant toutes les 3 minutes ----------
     Rotation sans répétition immédiate, horodatages plausibles, la Box
     Mystère revient environ une fois sur quatre, pause quand l'onglet est
     caché, fermeture mémorisée pour la session. ---------- */
  (function () {
    var toast = $('#sale-toast');
    if (!toast) return;
    try { if (window.sessionStorage.getItem('wise_toast_off') === '1') return; } catch (e) {}
    var dataEl = $('#sale-toast-data');
    var pool = [];
    try { pool = JSON.parse(dataEl.textContent); } catch (e) {}
    pool = pool.filter(function (p) { return p && p.name && p.img; });
    if (!pool.length) return;
    var boxes = pool.filter(function (p) { return p.box; });
    var items = pool.filter(function (p) { return !p.box; });

    var FIRST = ['Léa', 'Hugo', 'Camille', 'Nathan', 'Manon', 'Enzo', 'Chloé', 'Rayan', 'Inès', 'Tom', 'Sarah', 'Lucas', 'Emma', 'Théo', 'Lina', 'Adam', 'Jade', 'Noah', 'Zoé', 'Mehdi', 'Clara', 'Louis', 'Anaïs', 'Kylian'];
    var CITIES = ['Paris', 'Lyon', 'Marseille', 'Toulouse', 'Lille', 'Bordeaux', 'Nantes', 'Nice', 'Strasbourg', 'Rennes', 'Montpellier', 'Grenoble', 'Angers', 'Dijon', 'Reims', 'Tours', 'Orléans', 'Metz'];
    var LETTERS = 'BCDGLMNPRSTV';

    function pick(list, not) {
      var v;
      do { v = list[Math.floor(Math.random() * list.length)]; } while (list.length > 1 && v === not);
      return v;
    }
    function lang() { return ((document.documentElement.lang||'fr').toLowerCase().slice(0,2)==='en'?'en':((document.documentElement.lang||'fr').toLowerCase().slice(0,2)==='es'?'es':'fr')); }

    var lastName = null, lastItem = null, count = 0, hideTimer = null;
    function show() {
      if (document.hidden) return;
      count += 1;
      var useBox = boxes.length && (count % 4 === 0 || !items.length);
      var item = pick(useBox ? boxes : items, lastItem);
      lastItem = item;
      var name = pick(FIRST, lastName);
      lastName = name;
      var initial = LETTERS[Math.floor(Math.random() * LETTERS.length)];
      var city = pick(CITIES, null);
      var mins = 3 + Math.floor(Math.random() * 40);
      var en = lang() === 'en';
      $('#sale-toast-img').src = item.img;
      $('#sale-toast-img').alt = item.name;
      $('#sale-toast-name').textContent = name + ' ' + initial + '. · ' + city;
      $('#sale-toast-prod').textContent = (en ? (item.box ? 'ordered the ' : 'ordered ') : (item.box ? 'a commandé la ' : 'a commandé ')) + item.name;
      $('#sale-toast-time').textContent = en ? (mins + ' min ago') : ('il y a ' + mins + ' min');
      var link = $('#sale-toast-link');
      if (link && item.url) link.href = item.url;
      toast.classList.add('is-on');
      toast.setAttribute('aria-hidden', 'false');
      clearTimeout(hideTimer);
      hideTimer = setTimeout(hide, 8000);
    }
    function hide() {
      toast.classList.remove('is-on');
      toast.setAttribute('aria-hidden', 'true');
    }
    var close = toast.querySelector('[data-st-close]');
    if (close) close.addEventListener('click', function (e) {
      e.preventDefault();
      hide();
      try { window.sessionStorage.setItem('wise_toast_off', '1'); } catch (err) {}
      clearInterval(loop);
    });
    setTimeout(show, 25000);
    var loop = setInterval(show, 180000);
  })();

  /* ---------- Tiroir : emballage cadeau (attribut) et note de commande ---------- */
  (function () {
    var gift = $('[data-gift-wrap]');
    if (gift) {
      gift.addEventListener('change', function () {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { 'Emballage cadeau': gift.checked ? 'Oui' : '' } })
        }).then(function () {
          announce(gift.checked ? 'Emballage cadeau ajouté' : 'Emballage cadeau retiré');
        }).catch(function () {});
      });
    }
    var noteToggle = $('[data-note-toggle]');
    var note = $('[data-order-note]');
    if (noteToggle && note) {
      noteToggle.addEventListener('click', function () {
        var open = note.hidden;
        note.hidden = !open;
        noteToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) note.focus();
      });
      if (note.value.trim()) { note.hidden = false; noteToggle.setAttribute('aria-expanded', 'true'); }
      note.addEventListener('blur', function () {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: note.value.trim() })
        }).catch(function () {});
      });
    }
  })();

  /* ---------- Zoom d'image produit : clic pour agrandir, molette pour
     zoomer, glisser pour se déplacer, Échap ou clic hors image pour fermer.
     Au tactile, le pincement natif prend le relais. ---------- */
  (function () {
    var pdpImg = $('.pdp img');
    if (!pdpImg) return;
    var overlay = null, img = null, scale = 1, tx = 0, ty = 0, dragging = false, sx = 0, sy = 0;
    function apply() {
      img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
    }
    function open(src) {
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'zoomov';
        overlay.innerHTML = '<img alt="">' +
          '<button type="button" class="zoomov__close" aria-label="Fermer">&#10005;</button>' +
          '<span class="zoomov__hint">Molette pour zoomer, glissez pour explorer</span>';
        document.body.appendChild(overlay);
        img = overlay.querySelector('img');
        overlay.addEventListener('click', function (e) {
          if (e.target === overlay || e.target.closest('.zoomov__close')) close();
        });
        overlay.addEventListener('wheel', function (e) {
          e.preventDefault();
          scale = Math.min(4, Math.max(1, scale - Math.sign(e.deltaY) * 0.3));
          if (scale === 1) { tx = ty = 0; }
          apply();
        }, { passive: false });
        img.addEventListener('pointerdown', function (e) {
          if (scale <= 1) return;
          dragging = true; sx = e.clientX - tx; sy = e.clientY - ty;
          overlay.classList.add('is-drag');
          img.setPointerCapture(e.pointerId);
        });
        img.addEventListener('pointermove', function (e) {
          if (!dragging) return;
          tx = e.clientX - sx; ty = e.clientY - sy; apply();
        });
        img.addEventListener('pointerup', function () {
          dragging = false; overlay.classList.remove('is-drag');
        });
        img.addEventListener('dblclick', function () {
          scale = scale > 1 ? 1 : 2; if (scale === 1) { tx = ty = 0; } apply();
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') close();
        });
      }
      scale = 1; tx = ty = 0;
      img.src = src;
      apply();
      overlay.classList.add('is-on');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      if (overlay) overlay.classList.remove('is-on');
      document.body.style.overflow = '';
    }
    $all('.pdp img').forEach(function (el) {
      if (el.closest('.card') || el.width < 120) return;
      el.addEventListener('click', function () {
        open(el.currentSrc || el.src);
      });
    });
  })();

  /* ---------- Achat direct (sans Shop Pay) ---------- */
  var buyNow = $('[data-buy-now]');
  if (buyNow) {
    buyNow.addEventListener('click', function () {
      var form = $('#pdp-form');
      if (!form) return;
      var id = form.querySelector('[name="id"]');
      if (!id) return;
      buyNow.disabled = true;

      /* Tunnel Scalify : ajout au panier, pixel d'attribution, caisse externe.
         Repli sur le comportement d'origine si le script n'est pas chargé. */
      if (typeof window._scalifyGo === 'function') {
        window._scalifyGo({ buyNowForm: form });
        return;
      }

      var qty = form.querySelector('[name="quantity"]');
      fetch(routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(id.value, 10), quantity: qty ? parseInt(qty.value, 10) || 1 : 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = '/checkout';
      }).catch(function () {
        buyNow.disabled = false;
        window.location.href = routes.cart;
      });
    });
  }

  /* ---------- Compte : afficher/masquer le mot de passe ---------- */
  $all('[data-pw-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = document.getElementById(btn.getAttribute('data-pw-toggle'));
      if (!input) return;
      input.type = input.type === 'password' ? 'text' : 'password';
      btn.setAttribute('aria-label', input.type === 'password' ? 'Afficher le mot de passe' : 'Masquer le mot de passe');
    });
  });

  /* ---------- Compte : robustesse du mot de passe ---------- */
  var pwInput = $('[data-pw-strength]');
  if (pwInput) {
    var bars = $all('#pw-strength i');
    var label = $('#pw-strength-label');
    var levels = [
      { txt: 'Choisissez un mot de passe', color: '' },
      { txt: 'Mot de passe faible', color: '#DC2626' },
      { txt: 'Peut mieux faire', color: '#FF8C42' },
      { txt: 'Bon mot de passe', color: '#FBBF24' },
      { txt: 'Excellent mot de passe', color: '#16A34A' }
    ];
    pwInput.addEventListener('input', function () {
      var pw = pwInput.value;
      var score = 0;
      if (pw.length >= 8) score++;
      if (pw.length >= 12) score++;
      if (/[A-Z]/.test(pw) && /[a-z]/.test(pw)) score++;
      if (/\d/.test(pw) && /[^A-Za-z0-9]/.test(pw)) score++;
      bars.forEach(function (bar, i) {
        bar.style.background = i < score ? levels[score].color : '';
      });
      if (label) {
        label.textContent = levels[score].txt;
        label.style.color = score ? levels[score].color : '';
      }
    });
  }

  /* ---------- Compte : bascule connexion / récupération ---------- */
  var loginPane = $('#login-pane');
  var recoverPane = $('#recover-pane');
  if (loginPane && recoverPane) {
    function showRecover(e) {
      if (e) e.preventDefault();
      loginPane.hidden = true;
      recoverPane.hidden = false;
    }
    function showLogin(e) {
      if (e) e.preventDefault();
      recoverPane.hidden = true;
      loginPane.hidden = false;
    }
    $all('[data-show-recover]').forEach(function (a) { a.addEventListener('click', showRecover); });
    $all('[data-show-login]').forEach(function (a) { a.addEventListener('click', showLogin); });
    if (window.location.hash === '#recover' || recoverPane.querySelector('.form-ok, .form-err')) showRecover();
  }

  /* ---------- Compte : onglets (avec ancres #favoris, #avantages…) ---------- */
  function showAcctTab(key) {
    var found = false;
    $all('[data-acct-tab]').forEach(function (t) {
      var active = t.getAttribute('data-acct-tab') === key;
      t.classList.toggle('is-active', active);
      if (active) found = true;
    });
    if (!found) return;
    $all('[data-acct-panel]').forEach(function (panel) {
      panel.classList.toggle('is-active', panel.getAttribute('data-acct-panel') === key);
    });
  }
  $all('[data-acct-tab]').forEach(function (tab) {
    tab.addEventListener('click', function () { showAcctTab(tab.getAttribute('data-acct-tab')); });
  });
  var acctHashMap = { '#commandes': 'orders', '#favoris': 'wishlist', '#avantages': 'rewards', '#parametres': 'settings' };
  if (acctHashMap[window.location.hash]) showAcctTab(acctHashMap[window.location.hash]);

  /* ---------- Compte : formulaires d'adresse ---------- */
  $all('[data-addr-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = document.getElementById(btn.getAttribute('data-addr-toggle'));
      if (form) form.hidden = !form.hidden;
    });
  });
  $all('select[data-default]').forEach(function (select) {
    var def = select.getAttribute('data-default');
    if (!def) return;
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].value === def || select.options[i].text === def) {
        select.selectedIndex = i;
        break;
      }
    }
  });

  /* ---------- Ajout rapide depuis la grille (choix de la taille) ---------- */
  (function () {
    var quicks = $all('[data-card-quick]');
    if (!quicks.length) return;

    function close(wrap) {
      var panel = wrap.querySelector('[data-quick-panel]');
      var opener = wrap.querySelector('[data-quick-open]');
      if (!panel || panel.hidden) return;
      panel.hidden = true;
      if (opener) opener.setAttribute('aria-expanded', 'false');
    }

    function closeAll(except) {
      quicks.forEach(function (wrap) { if (wrap !== except) close(wrap); });
    }

    quicks.forEach(function (wrap) {
      var opener = wrap.querySelector('[data-quick-open]');
      var panel = wrap.querySelector('[data-quick-panel]');
      var closer = wrap.querySelector('[data-quick-close]');
      if (!opener || !panel) return;

      opener.addEventListener('click', function () {
        var willOpen = panel.hidden;
        closeAll(wrap);
        panel.hidden = !willOpen;
        opener.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });

      if (closer) closer.addEventListener('click', function () { close(wrap); });

      panel.querySelectorAll('[data-quick-variant]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = parseInt(btn.getAttribute('data-quick-variant'), 10);
          if (!id || btn.disabled) return;
          btn.disabled = true;
          btn.classList.add('is-loading');
          addToCart({ id: id, quantity: 1 })
            .then(function () {
              var card = wrap.closest('.card');
              if (window.wiseFlyToCart && card) window.wiseFlyToCart(card.querySelector('.card__img img'));
              close(wrap);
              opener.classList.add('is-added');
              opener.textContent = 'Ajouté au panier';
              announce('Article ajouté au panier');
              setTimeout(function () {
                opener.classList.remove('is-added');
                opener.textContent = 'Ajouter au panier';
              }, 1800);
            })
            .catch(function () { window.location.href = routes.cart; })
            .then(function () {
              btn.disabled = false;
              btn.classList.remove('is-loading');
            });
        });
      });
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-card-quick]')) closeAll(null);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll(null);
    });
  })();

  /* ---------- Filtres de collection / recherche ---------- */
  (function () {
    var facets = $('[data-facets]');
    if (!facets) return;
    var toggle = facets.querySelector('[data-facets-toggle]');
    var panel = facets.querySelector('[data-facets-panel]');
    if (!toggle || !panel) return;

    // Ouvert d'office quand des filtres sont déjà actifs.
    if (facets.querySelector('.facets__pill')) {
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
    }

    toggle.addEventListener('click', function () {
      var open = panel.hidden;
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) announce('Filtres ouverts');
    });

    // Les champs vides ne doivent pas finir dans l'URL.
    function submitClean() {
      panel.querySelectorAll('input[type="number"]').forEach(function (input) {
        if (!input.value) input.disabled = true;
      });
      panel.submit();
    }

    panel.addEventListener('submit', function (event) {
      event.preventDefault();
      submitClean();
    });

    // Une case cochée applique le filtre immédiatement ; les prix attendent la validation.
    panel.addEventListener('change', function (event) {
      if (event.target.type !== 'checkbox') return;
      submitClean();
    });
  })();

  /* ---------- Volume 3D : inclinaison des cartes et vol vers le panier ---------- */
  (function () {
    var noMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Inclinaison au survol : cartes produit et cartes d'univers.
       Le mouvement est calculé une fois par image pour rester fluide. */
    /* L'article s'envole vers l'icône du panier. */
    var cartIcon = $('[data-drawer-open]');

    window.wiseFlyToCart = function (source) {
      if (noMotion || !cartIcon || !source) return;
      var img = source.tagName === 'IMG' ? source : source.querySelector('img');
      if (!img || !img.currentSrc && !img.src) return;
      var from = img.getBoundingClientRect();
      var to = cartIcon.getBoundingClientRect();
      if (!from.width || !to.width) return;

      var size = Math.min(from.width, 120);
      var fly = document.createElement('div');
      fly.className = 'fly-cart';
      fly.style.left = from.left + (from.width - size) / 2 + 'px';
      fly.style.top = from.top + 'px';
      fly.style.width = size + 'px';
      fly.style.height = size + 'px';
      var clone = document.createElement('img');
      clone.src = img.currentSrc || img.src;
      clone.alt = '';
      fly.appendChild(clone);
      document.body.appendChild(fly);

      var dx = (to.left + to.width / 2) - (from.left + from.width / 2);
      var dy = (to.top + to.height / 2) - (from.top + size / 2);

      var anim = fly.animate([
        { transform: 'translate3d(0,0,0) rotateY(0deg) scale(1)', opacity: 1, offset: 0 },
        { transform: 'translate3d(' + dx * 0.55 + 'px,' + (dy * 0.28 - 120) + 'px,0) rotateY(220deg) scale(.72)', opacity: 1, offset: 0.55 },
        { transform: 'translate3d(' + dx + 'px,' + dy + 'px,0) rotateY(400deg) scale(.12)', opacity: 0, offset: 1 }
      ], { duration: 900, easing: 'cubic-bezier(.45,.05,.35,1)' });

      anim.onfinish = function () {
        fly.remove();
        cartIcon.classList.remove('is-hit');
        void cartIcon.offsetWidth;
        cartIcon.classList.add('is-hit');
        setTimeout(function () { cartIcon.classList.remove('is-hit'); }, 520);
      };
    };
  })();

  /* ---------- Box Mystère : étoiles, cadeau interactif, inclinaison, achat ---------- */
  (function () {
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Champ d'étoiles du héros
    var canvas = $('[data-bxm-stars]');
    if (canvas && canvas.getContext && !reduced) {
      var ctx = canvas.getContext('2d');
      var stars = [];
      function sizeCanvas() {
        canvas.width = canvas.offsetWidth;
        canvas.height = canvas.offsetHeight;
      }
      sizeCanvas();
      window.addEventListener('resize', sizeCanvas);
      var palette = ['255,255,255', '255,77,77', '255,140,66'];
      for (var i = 0; i < 70; i++) {
        stars.push({
          x: Math.random(), y: Math.random(),
          r: Math.random() * 1.8 + 0.6,
          vy: (Math.random() * 0.06 + 0.02) * (Math.random() < 0.5 ? -1 : 1),
          tw: Math.random() * Math.PI * 2,
          ts: Math.random() * 0.03 + 0.008,
          c: palette[i % palette.length]
        });
      }
      (function loop() {
        if (!document.hidden && canvas.offsetParent !== null) {
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          stars.forEach(function (st) {
            st.tw += st.ts;
            st.y += st.vy / canvas.height;
            if (st.y < -0.02) st.y = 1.02;
            if (st.y > 1.02) st.y = -0.02;
            var alpha = 0.25 + Math.abs(Math.sin(st.tw)) * 0.65;
            ctx.beginPath();
            ctx.arc(st.x * canvas.width, st.y * canvas.height, st.r, 0, Math.PI * 2);
            ctx.fillStyle = 'rgba(' + st.c + ',' + alpha.toFixed(2) + ')';
            ctx.fill();
          });
        }
        requestAnimationFrame(loop);
      })();
    }

    // Le cadeau réagit : secousse et gerbe d'étincelles
    var gift = $('[data-bxm-gift]');
    if (gift) {
      var burst = function () {
        if (gift.dataset.dragging === '1') { gift.dataset.dragging = ''; return; }
        gift.classList.remove('is-poked');
        void gift.offsetWidth;
        gift.classList.add('is-poked');
        for (var i = 0; i < 14; i++) {
          var sp = document.createElement('span');
          sp.className = 'bxm-spark';
          var angle = (Math.PI * 2 * i) / 14 + Math.random() * 0.4;
          var dist = 70 + Math.random() * 70;
          sp.style.setProperty('--dx', Math.cos(angle) * dist + 'px');
          sp.style.setProperty('--dy', Math.sin(angle) * dist + 'px');
          gift.appendChild(sp);
          (function (node) { setTimeout(function () { node.remove(); }, 850); })(sp);
        }
      };
      gift.addEventListener('click', burst);
      gift.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); burst(); }
      });

      // On attrape le cube pour le faire tourner ; il reste ensuite dans la
      // position choisie. Un simple clic déclenche toujours la gerbe.
      var cube = gift.querySelector('.bxm3__box');
      if (cube && window.PointerEvent && !reduced) {
        var hold = null;
        var angleX = -16, angleY = -28;
        gift.addEventListener('pointerdown', function (e) {
          hold = { x: e.clientX, y: e.clientY, rx: angleX, ry: angleY, moved: false };
          cube.classList.add('is-held');
          cube.style.transform = 'rotateX(' + angleX + 'deg) rotateY(' + angleY + 'deg)';
          if (gift.setPointerCapture) gift.setPointerCapture(e.pointerId);
        });
        gift.addEventListener('pointermove', function (e) {
          if (!hold) return;
          var dx = e.clientX - hold.x;
          var dy = e.clientY - hold.y;
          if (Math.abs(dx) + Math.abs(dy) > 6) hold.moved = true;
          angleY = hold.ry + dx * 0.55;
          angleX = Math.max(-75, Math.min(75, hold.rx - dy * 0.55));
          cube.style.transform = 'rotateX(' + angleX + 'deg) rotateY(' + angleY + 'deg)';
        });
        var release = function () {
          if (!hold) return;
          if (hold.moved) gift.dataset.dragging = '1';
          cube.classList.remove('is-held');
          cube.classList.add('is-freed');
          hold = null;
        };
        gift.addEventListener('pointerup', release);
        gift.addEventListener('pointercancel', release);
      }
    }

    // Inclinaison 3D des cartes d'offre
    if (!reduced) {
      $all('[data-bxm-tilt]').forEach(function (card) {
        card.addEventListener('mousemove', function (e) {
          var r = card.getBoundingClientRect();
          var rx = ((e.clientY - r.top) / r.height - 0.5) * -7;
          var ry = ((e.clientX - r.left) / r.width - 0.5) * 7;
          card.style.transform = 'perspective(900px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg)';
        });
        card.addEventListener('mouseleave', function () {
          card.style.transform = '';
        });
      });
    }

    // Achat sur place : options → variante → panier
    $all('[data-bxm-offer]').forEach(function (offer) {
      var dataEl = offer.querySelector('[data-bxm-variants]');
      var btn = offer.querySelector('[data-bxm-add]');
      if (!dataEl || !btn) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var selects = $all('select[data-bxm-opt]', offer);

      function current() {
        var chosen = selects.map(function (s) { return s.value; });
        return variants.find(function (v) { return v.opts.join('|') === chosen.join('|'); });
      }
      function sync() {
        var v = current();
        btn.disabled = !v || !v.available;
        btn.textContent = (!v || v.available) ? 'Ajouter au panier' : 'Épuisé dans cette combinaison';
      }
      selects.forEach(function (sel) { sel.addEventListener('change', sync); });
      sync();

      btn.addEventListener('click', function () {
        var v = current();
        if (!v || !v.available) return;
        btn.disabled = true;
        addToCart({ id: v.id, quantity: 1 })
          .then(function () {
            btn.classList.add('is-added');
            btn.textContent = 'Ajouté au panier';
            announce('Box ajoutée au panier');
            setTimeout(function () {
              btn.classList.remove('is-added');
              sync();
            }, 1800);
          })
          .catch(function () { window.location.href = routes.cart; })
          .then(function () { btn.disabled = false; });
      });
    });
  })();

  /* ---------- Parrainage natif : copie, partage et garde-fous de saisie ---------- */
  (function () {
    function copyText(text, done) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done, function () { legacyCopy(text); done(); });
      } else { legacyCopy(text); done(); }
    }
    function legacyCopy(text) {
      var area = document.createElement('textarea');
      area.value = text;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.left = '-9999px';
      document.body.appendChild(area);
      area.select();
      try { document.execCommand('copy'); } catch (e) { /* silencieux */ }
      area.remove();
    }
    function feedback(message) {
      var fb = $('[data-ref-feedback]');
      if (fb) { fb.textContent = message; fb.hidden = false; }
      announce(message);
    }

    $all('[data-ref-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-code') || '';
        copyText(code, function () { feedback('Code copié : ' + code); });
      });
    });

    $all('[data-ref-share]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-code') || '';
        var text = 'Mon code parrain ' + (window.WiseShopName || 'Wise') + ' : ' + code +
          ' — 5 \u20ac offerts sur ta premi\u00e8re commande d\u00e8s 20 \u20ac d\'achat.';
        if (navigator.share) {
          navigator.share({ title: document.title, text: text, url: window.location.origin }).catch(function () {});
        } else {
          copyText(text + ' ' + window.location.origin, function () { feedback('Message de parrainage copié — collez-le où vous voulez.'); });
        }
      });
    });

    /* Garde-fous côté client : forme du code et auto-parrainage. Le reste
       (existence du parrain, unicité, première commande) est contrôlé côté
       admin avant tout enregistrement. */
    var claim = document.getElementById('ref-claim');
    if (claim) {
      claim.addEventListener('submit', function (e) {
        var input = document.getElementById('ref-claim-input');
        var err = $('[data-ref-claim-error]');
        if (!input) return;
        var value = input.value.trim().toUpperCase();
        input.value = value;
        if (err) err.hidden = true;
        var block = function (message) {
          e.preventDefault();
          if (err) { err.textContent = message; err.hidden = false; }
          announce(message);
        };
        if (!/^WISE-[A-Z0-9]{4,12}$/.test(value)) {
          return block('Un code de parrainage a la forme WISE-A12345 — v\u00e9rifiez la saisie.');
        }
        var own = (input.getAttribute('data-own-code') || '').toUpperCase();
        if (own && value === own) {
          return block('Ce code est le v\u00f4tre : le parrainage se fait entre deux comptes diff\u00e9rents.');
        }
        storageSet(REF_CODE_KEY, value);
        attachRefAttribute();
      });
    }
  })();

  /* ---------- Compte : modification des coordonnées sur place ---------- */
  (function () {
    var toggle = $('[data-coord-toggle]');
    var panel = $('[data-coord-panel]');
    if (!toggle || !panel) return;
    function open(state) {
      panel.hidden = !state;
      toggle.setAttribute('aria-expanded', state ? 'true' : 'false');
      var label = toggle.querySelector('span');
      if (label) label.textContent = state ? 'Fermer' : 'Modifier mes coordonnées';
    }
    toggle.addEventListener('click', function () { open(panel.hidden); });
    var cancel = panel.querySelector('[data-coord-cancel]');
    if (cancel) cancel.addEventListener('click', function () { open(false); });
    // Retour d'envoi : le panneau s'ouvre sur la confirmation.
    if (panel.querySelector('[data-form-success]')) open(true);
  })();

  /* ---------- Plusieurs formulaires de contact sur une même page ----------
     Shopify marque tous les formulaires comme envoyés : on ne garde que celui
     dont l'identifiant correspond à l'ancre de retour. */
  (function () {
    var successes = $all('[data-form-success]');
    if (successes.length < 2) return;
    var hash = (window.location.hash || '').replace('#', '');
    successes.forEach(function (el) {
      if (hash && el.getAttribute('data-form-success') !== hash) {
        var form = el.closest('form');
        if (form) form.parentNode.removeChild(el);
      }
    });
  })();

  /* ---------- Copie d'un texte quelconque ---------- */
  $all('[data-copy-text]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var value = btn.getAttribute('data-copy-text');
      if (!value || !navigator.clipboard) return;
      var label = btn.querySelector('span');
      var original = label ? label.textContent : btn.textContent;
      navigator.clipboard.writeText(value).then(function () {
        if (label) label.textContent = 'Copié';
        else btn.textContent = 'Copié';
        announce('Copié dans le presse-papiers');
        setTimeout(function () {
          if (label) label.textContent = original;
          else btn.textContent = original;
        }, 1600);
      }).catch(function () {});
    });
  });

  /* ---------- Avis : photos jointes (aperçu avant envoi) ---------- */
  $all('[data-revs-photo]').forEach(function (wrap) {
    var input = wrap.querySelector('[data-revs-photo-input]');
    var thumbs = wrap.querySelector('[data-revs-photo-thumbs]');
    var note = wrap.querySelector('[data-revs-photo-note]');
    var field = wrap.parentNode.querySelector('[data-revs-photo-field]');
    if (!input || !thumbs) return;
    var picked = [];
    var MAX = 3;

    function render() {
      thumbs.innerHTML = '';
      picked.forEach(function (file, i) {
        var box = document.createElement('div');
        box.className = 'revs-photo__thumb';
        var img = document.createElement('img');
        img.src = URL.createObjectURL(file);
        img.alt = file.name;
        var x = document.createElement('button');
        x.type = 'button';
        x.className = 'revs-photo__x-btn';
        x.setAttribute('aria-label', 'Retirer ' + file.name);
        x.innerHTML = '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
        x.addEventListener('click', function () {
          picked.splice(i, 1);
          render();
        });
        box.appendChild(img);
        box.appendChild(x);
        thumbs.appendChild(box);
      });
      if (field) {
        field.value = picked.length
          ? picked.length + ' photo(s) à recevoir : ' + picked.map(function (f) { return f.name; }).join(', ')
          : 'Aucune photo';
      }
      if (note) {
        note.hidden = picked.length === 0;
        note.textContent = picked.length
          ? 'Vos photos sont prêtes. Après l’envoi de l’avis, un bouton vous permettra de nous les transmettre en un geste — elles seront ajoutées à votre avis lors de la validation.'
          : '';
      }
    }

    input.addEventListener('change', function () {
      var files = Array.prototype.slice.call(input.files || []);
      files.forEach(function (f) {
        if (picked.length < MAX && f.type.indexOf('image/') === 0) picked.push(f);
      });
      input.value = '';
      render();
      if (files.length && picked.length >= MAX) announce('Trois photos maximum');
    });
  });

  /* ---------- FAQ : « Cette réponse vous a aidé ? » ---------- */
  $all('[data-faq-help]').forEach(function (wrap) {
    wrap.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-faq-vote]');
      if (!btn) return;
      var vote = btn.getAttribute('data-faq-vote');
      if (vote === 'yes') {
        wrap.innerHTML = '<span class="faq-help__thanks">Merci pour votre retour !</span>';
      } else {
        wrap.innerHTML = '<span class="faq-help__thanks">Merci ! <a href="/pages/contact">Posez-nous la question directement</a>, on répond sous 24 h.</span>';
      }
      announce('Merci pour votre retour');
    });
  });

  /* ---------- Suivi : détection du transporteur + estimation ---------- */
  (function () {
    var input = $('#track-number');
    var detect = $('#track-detect');
    if (input && detect) {
      var patterns = [
        { re: /^1Z[0-9A-Z]{8,16}$/i, name: 'UPS', key: 'ups' },
        { re: /^[A-Z]{2}\d{9}FR$/i, name: 'Chronopost', key: 'chronopost' },
        { re: /^(6A|6C|6G|6H|6M|6Q|7Q|8L|8Q|8R|9L|9V)[0-9A-Z]{9,11}$/i, name: 'Colissimo', key: 'colissimo' }
      ];
      input.addEventListener('input', function () {
        var v = input.value.replace(/\s+/g, '');
        var hit = null;
        for (var i = 0; i < patterns.length; i++) {
          if (patterns[i].re.test(v)) { hit = patterns[i]; break; }
        }
        if (hit) {
          var btn = document.querySelector('.carrier[data-carrier="' + hit.key + '"]');
          if (btn && !btn.classList.contains('is-active')) btn.click();
          detect.querySelector('span').textContent = 'Transporteur détecté : ' + hit.name;
          detect.classList.add('is-on');
        } else {
          detect.classList.remove('is-on');
        }
      });
    }

    // Fenêtres de livraison estimées, en français.
    function frRange(minDays, maxDays) {
      var months = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
      function fmt(offset) {
        var d = new Date();
        d.setDate(d.getDate() + offset);
        return d.getDate() + ' ' + months[d.getMonth()];
      }
      return 'entre le ' + fmt(minDays) + ' et le ' + fmt(maxDays);
    }
    $all('[data-eta-range]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 7;
      var max = parseInt(el.getAttribute('data-max'), 10) || 12;
      el.textContent = frRange(min, max);
    });
  })();

  /* ---------- Vente flash : compte à rebours ---------- */
  $all('[data-flash]').forEach(function (section) {
    var endAttr = section.getAttribute('data-end');
    if (!endAttr) { section.hidden = true; return; }
    var end = new Date(endAttr.replace(' ', 'T'));
    if (isNaN(end.getTime())) { section.hidden = true; return; }
    var cells = {
      d: section.querySelector('[data-flash-d]'),
      h: section.querySelector('[data-flash-h]'),
      m: section.querySelector('[data-flash-m]'),
      s: section.querySelector('[data-flash-s]')
    };
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function tick() {
      var left = end.getTime() - Date.now();
      if (left <= 0) { section.hidden = true; clearInterval(timer); return; }
      var s = Math.floor(left / 1000);
      if (cells.d) cells.d.textContent = pad(Math.floor(s / 86400));
      if (cells.h) cells.h.textContent = pad(Math.floor(s % 86400 / 3600));
      if (cells.m) cells.m.textContent = pad(Math.floor(s % 3600 / 60));
      if (cells.s) cells.s.textContent = pad(s % 60);
    }
    tick();
    var timer = setInterval(tick, 1000);
  });

  /* ---------- Partage d'article : copie du lien ---------- */
  $all('[data-copy-link]').forEach(function (btn) {
    var label = btn.querySelector('span');
    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-copy-link');
      if (!url || !navigator.clipboard || !label) return;
      var original = label.textContent;
      navigator.clipboard.writeText(url).then(function () {
        label.textContent = 'Lien copié';
        announce('Lien de l\'article copié');
        setTimeout(function () { label.textContent = original; }, 1600);
      }).catch(function () {});
    });
  });

  /* ---------- Apparitions au défilement (simples + en cascade) ---------- */
  $all('.sec__head, .social-band, .member, .news, .how__head, .storyband__in > div:first-child, .rev__intro, .rev__bar, .page-head').forEach(function (el) {
    el.classList.add('reveal');
  });
  $all('.cols, .sec .grid, .promos, .how__grid, .storyband .pillars, .rev__scroll, .cart-trust, .contact-cards, .track-steps, .upsell__grid, .plp .grid--fixed, .acct-grid, .amb__rail, .posts, .art__nav').forEach(function (el) {
    el.classList.add('reveal-stagger');
  });
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.01, rootMargin: '0px 0px -40px 0px' });
    $all('.reveal, .reveal-stagger').forEach(function (el) { io.observe(el); });
  } else {
    $all('.reveal, .reveal-stagger').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Images : fondu au chargement ---------- */
  $all('img[loading="lazy"]').forEach(function (img) {
    if (img.complete && img.naturalWidth > 0) return;
    img.classList.add('lazy-fade');
    if (img.complete) { img.classList.add('is-loaded'); return; }
    img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
    img.addEventListener('error', function () { img.classList.add('is-loaded'); }, { once: true });
  });

  /* ---------- Retour en haut ---------- */
  var backTop = $('#back-top');
  if (backTop) {
    var onBackTopScroll = function () {
      backTop.classList.toggle('is-on', window.scrollY > 900);
    };
    window.addEventListener('scroll', onBackTopScroll, { passive: true });
    onBackTopScroll();
    backTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ---------- Recherche prédictive ---------- */
  var searchInput = $('#search-input');
  var suggestBox = $('#search-suggest');
  if (searchInput && suggestBox) {
    var suggestTimer = null;
    var lastQuery = '';
    function closeSuggest() { suggestBox.classList.remove('is-on'); }
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      clearTimeout(suggestTimer);
      if (q.length < 2) { closeSuggest(); return; }
      suggestTimer = setTimeout(function () {
        if (q === lastQuery) return;
        lastQuery = q;
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5&resources[options][fields]=title,vendor,product_type')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (((data || {}).resources || {}).results || {}).products || [];
            if (!products.length) {
              suggestBox.innerHTML = '<div class="search-suggest__none">Aucun résultat pour «&nbsp;' + esc(q) + '&nbsp;»</div>';
            } else {
              suggestBox.innerHTML = products.map(function (p) {
                var img = p.featured_image && p.featured_image.url ? '<img src="' + esc(p.featured_image.url) + '" alt="" width="44" height="50" loading="lazy">' : '<span style="width:44px;height:50px;border-radius:8px;background:#f3f3f3;flex-shrink:0"></span>';
                var price = parseFloat(p.price);
                var priceHtml = isNaN(price) ? esc(p.price) : formatMoney(Math.round(price * 100));
                return '<a class="search-suggest__item" href="' + esc(p.url) + '">' + img +
                  '<span class="search-suggest__i">' +
                  (p.vendor ? '<span class="search-suggest__v">' + esc(p.vendor) + '</span><br>' : '') +
                  '<span class="search-suggest__n">' + esc(p.title) + '</span></span>' +
                  '<span class="search-suggest__p">' + priceHtml + '</span></a>';
              }).join('') +
              '<a class="search-suggest__all" href="/search?type=product&q=' + encodeURIComponent(q) + '">Voir tous les résultats →</a>';
            }
            suggestBox.classList.add('is-on');
          })
          .catch(closeSuggest);
      }, 220);
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('.search')) closeSuggest();
    });
    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeSuggest(); return; }
      if (!suggestBox.classList.contains('is-on')) return;
      var items = $all('a', suggestBox);
      if (!items.length) return;
      var idx = items.indexOf($('.is-sel', suggestBox));
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        idx = e.key === 'ArrowDown' ? (idx + 1) % items.length : (idx - 1 + items.length) % items.length;
        items.forEach(function (a, i) { a.classList.toggle('is-sel', i === idx); });
        items[idx].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && idx !== -1) {
        e.preventDefault();
        window.location.href = items[idx].href;
      }
    });
  }

  /* ---------- Header intelligent : se masque en descendant ---------- */
  var head = $('.head');
  if (head) {
    var lastScrollY = window.scrollY;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y > 300 && y > lastScrollY + 8) head.classList.add('is-hidden');
      else if (y < lastScrollY - 8 || y <= 300) head.classList.remove('is-hidden');
      lastScrollY = y;
    }, { passive: true });
  }

  /* ---------- Galerie produit : flèches ---------- */
  var galPrev = $('[data-gal-prev]');
  var galNext = $('[data-gal-next]');
  if (galPrev && galNext) {
    var galIndex = 0;
    function galShow(i) {
      var thumbs = $all('[data-thumb]');
      if (!thumbs.length) return;
      galIndex = (i + thumbs.length) % thumbs.length;
      thumbs[galIndex].click();
    }
    galPrev.addEventListener('click', function () { galShow(galIndex - 1); });
    galNext.addEventListener('click', function () { galShow(galIndex + 1); });
    $all('[data-thumb]').forEach(function (t, i) {
      t.addEventListener('click', function () { galIndex = i; });
    });
  }

  /* ---------- Récemment consultés (fiche produit + accueil) ---------- */
  var RECENT_KEY = 'wise_recent_products';
  (function () {
    var currentEl = $('#recent-current');
    var current = null;
    if (currentEl) {
      try { current = JSON.parse(currentEl.textContent); } catch (e) {}
      if (current && (!current.handle || !current.url || !current.img)) current = null;
    }
    var recent = [];
    try { recent = JSON.parse(storageGet(RECENT_KEY) || '[]'); } catch (e) { recent = []; }

    // Nettoyage : entrées valides uniquement, sans doublons
    var seen = {};
    recent = recent.filter(function (p) {
      if (!p || !p.handle || !p.url || !p.img || seen[p.handle]) return false;
      seen[p.handle] = true;
      return true;
    });

    var toShow = current ? recent.filter(function (p) { return p.handle !== current.handle; }) : recent;
    var grid = $('#recent-grid');
    var wrap = $('#recent-viewed');
    if (grid && wrap && toShow.length) {
      grid.innerHTML = toShow.slice(0, 6).map(function (p) {
        return '<a class="recent__card" href="' + esc(p.url) + '">' +
          '<figure><img src="' + esc(p.img) + '" alt="" width="400" height="444" loading="lazy"></figure>' +
          '<div class="recent__body">' +
          '<div class="recent__n">' + esc(p.title) + '</div>' +
          '<div class="recent__p">' + formatMoney(p.price || 0) + '</div>' +
          '</div></a>';
      }).join('');
      wrap.hidden = false;
    }
    if (current) {
      storageSet(RECENT_KEY, JSON.stringify([current].concat(toShow).slice(0, 8)));
    } else if (recent.length) {
      storageSet(RECENT_KEY, JSON.stringify(recent.slice(0, 8)));
    }
    $all('[data-recent-clear]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        try { window.localStorage.removeItem(RECENT_KEY); } catch (e) {}
        if (wrap) wrap.hidden = true;
      });
    });
  })();

  /* ---------- Favoris ---------- */
  var WISH_KEY = 'wise_wishlist';
  function getWishlist() {
    try { return JSON.parse(storageGet(WISH_KEY) || '[]'); } catch (e) { return []; }
  }
  function setWishlist(list) {
    storageSet(WISH_KEY, JSON.stringify(list));
    renderWishState();
  }
  function isWished(handle) {
    return getWishlist().some(function (p) { return p.handle === handle; });
  }
  function renderWishState() {
    var list = getWishlist();
    $all('[data-wish-badge]').forEach(function (el) { el.hidden = list.length === 0; });
    $all('[data-wish-count]').forEach(function (el) { el.textContent = list.length; });
    $all('[data-wish]').forEach(function (btn) {
      var active = isWished(btn.getAttribute('data-handle'));
      btn.classList.toggle('is-active', active);
      var off = btn.querySelector('.wish-off');
      var on = btn.querySelector('.wish-on');
      if (off) off.hidden = active;
      if (on) on.hidden = !active;
    });
    var grid = $('[data-wish-grid]');
    var empty = $('[data-wish-empty]');
    if (grid) {
      grid.innerHTML = list.map(function (p) {
        return '<div class="wish-card"><a href="' + esc(p.url) + '">' +
          '<img src="' + esc(p.img) + '" alt="" width="400" height="444" loading="lazy">' +
          '<div class="wish-card__n">' + esc(p.title) + '</div>' +
          '<div class="wish-card__p">' + formatMoney(p.price) + '</div></a>' +
          '<button type="button" class="wish-card__rm" data-wish-remove="' + esc(p.handle) + '" aria-label="Retirer des favoris">' +
          '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>';
      }).join('');
      if (empty) empty.style.display = list.length ? 'none' : '';
      $all('[data-wish-remove]', grid).forEach(function (btn) {
        btn.addEventListener('click', function () {
          setWishlist(getWishlist().filter(function (p) { return p.handle !== btn.getAttribute('data-wish-remove'); }));
        });
      });
    }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-wish]') : null;
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-handle');
    var list = getWishlist();
    if (isWished(handle)) {
      list = list.filter(function (p) { return p.handle !== handle; });
    } else {
      list.unshift({
        handle: handle,
        title: btn.getAttribute('data-title'),
        url: btn.getAttribute('data-url'),
        img: btn.getAttribute('data-img'),
        price: parseInt(btn.getAttribute('data-price'), 10) || 0
      });
      list = list.slice(0, 40);
      btn.classList.add('is-pop');
      setTimeout(function () { btn.classList.remove('is-pop'); }, 400);
    }
    setWishlist(list);
  });
  renderWishState();

  /* ---------- Lightbox galerie produit ---------- */
  var lightbox = $('#lightbox');
  if (lightbox) {
    var lbImg = $('#lightbox-img');
    var mainImgEl = $('#pdp-main-img');
    function openLightbox() {
      if (!mainImgEl || lightbox.classList.contains('is-on')) return;
      lbImg.src = mainImgEl.src;
      lightbox.classList.add('is-on');
      lockScroll();
    }
    function closeLightbox() {
      if (!lightbox.classList.contains('is-on')) return;
      lightbox.classList.remove('is-on');
      unlockScroll();
    }
    if (mainImgEl) mainImgEl.addEventListener('click', openLightbox);
    var lbClose = $('[data-lightbox-close]');
    if (lbClose) lbClose.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLightbox(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLightbox(); });
    var lbPrev = $('[data-lightbox-prev]');
    var lbNext = $('[data-lightbox-next]');
    function lbNav(dir) {
      var thumbs = $all('[data-thumb]');
      if (!thumbs.length) return;
      var srcs = thumbs.map(function (t) { return t.getAttribute('data-src'); });
      var idx = srcs.indexOf(lbImg.src);
      if (idx === -1) idx = 0;
      idx = (idx + dir + srcs.length) % srcs.length;
      lbImg.src = srcs[idx];
      thumbs[idx].click();
    }
    if (lbPrev) lbPrev.addEventListener('click', function (e) { e.stopPropagation(); lbNav(-1); });
    if (lbNext) lbNext.addEventListener('click', function (e) { e.stopPropagation(); lbNav(1); });
  }

  /* ---------- Note de commande (sauvegarde automatique) ---------- */
  var cartNote = $('[data-cart-note]');
  if (cartNote) {
    cartNote.addEventListener('blur', function () {
      fetch(((window.WiseRoutes || {}).cartUpdate || '/cart/update') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: cartNote.value })
      }).catch(function () {});
    });
  }

  /* ---------- Héros : compteurs et parallax léger ---------- */
  $all('.hero__stat b').forEach(function (el) {
    var raw = el.textContent.trim();
    var m = raw.match(/^\+?\d[\d\s]*([.,]\d+)?$/);
    if (!m) return;
    var target = parseFloat(raw.replace(/\s/g, '').replace(',', '.').replace('+', ''));
    var prefix = raw.indexOf('+') === 0 ? '+' : '';
    var decimal = raw.indexOf('.') !== -1 || raw.indexOf(',') !== -1;
    var start = Date.now();
    var duration = 1200;
    var step = function () {
      var t = Math.min(1, (Date.now() - start) / duration);
      var val = target * t;
      el.textContent = prefix + (decimal ? val.toFixed(1) : Math.round(val).toLocaleString('fr-FR'));
      if (t < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  });
  var heroVisual = $('.hero__visual');
  if (heroVisual && window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y < 900) heroVisual.style.transform = 'translateY(' + y * -0.06 + 'px)';
    }, { passive: true });
  }

  /* ---------- Compteurs animés (page histoire) ---------- */
  var counters = $all('[data-counter]');
  if (counters.length && 'IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        cio.unobserve(entry.target);
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-target')) || 0;
        var suffix = el.getAttribute('data-suffix') || '';
        var decimal = String(el.getAttribute('data-target')).indexOf('.') !== -1;
        var start = Date.now();
        var duration = 1100;
        var step = function () {
          var t = Math.min(1, (Date.now() - start) / duration);
          var val = target * t;
          el.textContent = (decimal ? val.toFixed(1) : Math.round(val).toLocaleString('fr-FR')) + suffix;
          if (t < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    counters.forEach(function (el) { cio.observe(el); });
  } else {
    counters.forEach(function (el) {
      el.textContent = el.getAttribute('data-target') + (el.getAttribute('data-suffix') || '');
    });
  }
})();

/* ---------- Page Avis clients : filtres par note + pagination ---------- */
(function () {
  var page = document.querySelector('[data-reviews-page]');
  if (!page) return;
  var cards = Array.prototype.slice.call(page.querySelectorAll('[data-rev-card]'));
  var filters = Array.prototype.slice.call(page.querySelectorAll('[data-rev-filter]'));
  var moreBtn = page.querySelector('[data-rev-more]');
  var shownLabel = page.querySelector('[data-rev-shown]');
  var step = parseInt(page.getAttribute('data-initial'), 10) || 12;
  var visible = step;
  var current = 'all';

  function apply() {
    var pool = cards.filter(function (c) {
      if (current === 'all') return true;
      if (current === 'photos') return c.hasAttribute('data-has-photo');
      return c.getAttribute('data-rating') === current;
    });
    var i = 0;
    cards.forEach(function (c) { c.hidden = true; });
    pool.forEach(function (c, idx) {
      if (idx < visible) {
        c.hidden = false;
        c.style.animationDelay = Math.min(i * 0.04, 0.4) + 's';
        i++;
      }
    });
    var showing = Math.min(visible, pool.length);
    if (shownLabel) {
      shownLabel.textContent = showing + ' avis affiché' + (showing > 1 ? 's' : '') + ' sur ' + pool.length;
    }
    if (moreBtn) moreBtn.hidden = showing >= pool.length;
  }

  filters.forEach(function (btn) {
    btn.addEventListener('click', function () {
      filters.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      current = btn.getAttribute('data-rev-filter');
      visible = step;
      apply();
    });
  });
  if (moreBtn) {
    moreBtn.addEventListener('click', function () {
      visible += step;
      apply();
    });
  }
  apply();

  /* Visionneuse des photos clients */
  var lb = document.querySelector('[data-rev-lb]');
  if (lb) {
    var lbImg = lb.querySelector('[data-rev-lb-img]');
    var lbOpen = function (src) {
      lbImg.src = src;
      lb.hidden = false;
      document.body.style.overflow = 'hidden';
    };
    var lbClose = function () {
      lb.hidden = true;
      lbImg.src = '';
      document.body.style.overflow = '';
    };
    page.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rev-photo]');
      if (btn) lbOpen(btn.getAttribute('data-rev-photo'));
    });
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.closest('[data-rev-lb-close]')) lbClose();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !lb.hidden) lbClose();
    });
  }

  /* Après envoi du formulaire, ramener sur la confirmation */
  var form = document.querySelector('.revs-form');
  if (form && form.querySelector('.revs-form__success')) {
    form.scrollIntoView({ block: 'center' });
  }
})();

/* ==========================================================================
   AMBASSADEURS — lecture vidéo : une seule à la fois, façades cliquables
   (le lien externe reste fonctionnel sans JavaScript)
   ========================================================================== */
(function () {
  'use strict';
  var sections = document.querySelectorAll('[data-ambassadors]');
  if (!sections.length) return;

  sections.forEach(function (section) {
    section.addEventListener('play', function (event) {
      if (event.target.tagName !== 'VIDEO') return;
      section.querySelectorAll('video').forEach(function (video) {
        if (video !== event.target) video.pause();
      });
    }, true);

    section.querySelectorAll('.amb__facade[data-embed-src]').forEach(function (facade) {
      var src = facade.getAttribute('data-embed-src');
      if (!src) return;
      facade.addEventListener('click', function (event) {
        event.preventDefault();
        var iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.title = facade.getAttribute('data-embed-title') || 'Vidéo';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
        iframe.setAttribute('allowfullscreen', '');
        facade.parentNode.replaceChild(iframe, facade);
        section.querySelectorAll('video').forEach(function (video) { video.pause(); });
      });
    });
  });
})();
